export default {
    "tabDashboard": "Dashboard",
    "tabTemplates": "Template",
    "tabCampaigns": "Campagne",
    "tabDirectory": "Rubrica",
    "tabChannels": "Canali",
    "tabFlowBuilder": "Flow Builder",
    "tabNumbers": "Numerazioni",
    "tabVerify": "Verify",
    "tabConversation": "Conversation",
    "tabDevelopers": "Sviluppatori",
    "tabBilling": "Pagamenti e Fatture",
    "tabAnalytics": "Analytics",
    "tabFlows": "Flussi",
    "tabConfiguration": "Configuration",
    "tabReports" : "Rapporti",
    "mainTitle": "Titolo",
    "mainInsert": "Inserisci",
    "mainRequested": "Richiesto il",
    "mainCreatedAt": "Creato il",
    "mainCreatedBy": "Creato da",
    "mainVerifiedAt": "Verificato il",
    "mainWentWrong": "Qualcosa è andato storto. Si prega di riprovare più tardi.",
    "mainRequestFailed": "La richiesta non è andata a buon fine. Si prega di riprovare più tardi.",
    "mainTemplateAdded": "Un nuovo template è stato aggiunto con successo!",
    "mainTemplate": "Template",
    "mainClearTemplate": "Cancella Template",
    "mainAttach": "Allega",
    "mainSend": "Invia",
    "mainEnterYourMsg": "Inserisci il tuo messaggio",
    "mainTemplateOnly": "La finestra temporale di 24 ore è terminata. Seleziona un template",
    "mainParameter": "Parametro",
    "mainHeaderParameter": "Parametro Header",
    "mainURLParameter": "Parametro URL",
    "mainUploadImage": "Carica un File Immagine",
    "mainUploadDoc": "Carica un Documento",
    "mainUploadVideo": "Carica un File Video",
    "mainClearImg": "Cancella Immagine",
    "mainClearDoc": "Cancella Documento",
    "mainClearVideo": "Cancella Video",
    "mainReplace": "Sostituisci",
    "mainSelectTemplate": "Seleziona Template",
    "mainSearchTemplate": "Cerca per Titolo del Template",
    "mainStatus": "Stato",
    "mainNoTemplates": "Nessun template trovato!",
    "mainFilterBy": "Filtra per",
    "mainThisYear": "Quest'anno",
    "mainThisMonth": "Questo mese",
    "mainThisWeek": "Questa settimana",
    "mainSendOtp": "OTP Inviati",
    "mainDeliveredOtp": "OTP Consegnati",
    "mainVerifiedOtp": "OTP Verificati",
    "mainLogs": "Dati Recenti",
    "mainViewAllLogs": "Visualizza tutti i dati",
    "mainReports": "Report",
    "mainAllReports": "Visualizza tutti i report",
    "mainSMS": "SMS",
    "mainVoice": "Voce",
    "mainEmail": "Email",
    "mainInvalid": "Invalido",
    "mainVerified": "Verificato",
    "mainUnverified": "Non verificato",
    "mainHidden": "nascosto",
    "mainVisible": "visibile",
    "mainName": "Nome",
    "mainChannel": "Canale",
    "mainId": "ID",
    "mainTo": "A",
    "mainAttempts": "Tentativi",
    "mainNoLogs": "Nessun dato trovato!",
    "mainComingSoon": "Coming soon...",
    "mainAddTemplate": "Aggiungi Template",
    "mainMessage": "Messaggio",
    "mainMedium": "Medio",
    "mainApproved": "Approvato",
    "mainPending": "In fase di verifica",
    "mainRejected": "Rifiutato",
    "mainAttention": "Richiede modifiche",
    "mainDeleted": "Eliminato",
    "mainEnable":"Abilita",
    "mainDisable":"Disabilita",
    "mainClose": "Chiudi",
    "mainSave": "Salva",
    "mainActive": "Attiva",
    "mainCopyToClipboard": "Copia negli appunti",
    "mainFlowName": "Nome del flusso",
    "mainFlowId": "ID Flusso",
    "mainValidity": "Validità",
    "mainEmailAddress": "Indirizzo Email",
    "mainEmailInvalid": "Inserisci un indirizzo email valido",
    "mainEmailRequired": "Inserisci un indirizzo email valido",
    "mainSelectEmailTemplate": "Seleziona un Template Email",
    "mainSelectVoiceTemplate": "Seleziona un Template Voce",
    "mainEmailTemplateRequired": "Inserisci un Template Email",
    "mainVoiceTemplateRequired": "Seleziona un Template Voce",
    "mainCountryRequired": "Seleziona una Nazione",
    "mainSelectNumberRequired": "Inserisci un numero",
    "mainSendAnyway": "Invia comunque",
    "mainSendAfterTimeIntervel": "Invia dopo un intervallo di tempo",
    "mainSelectChannel": "Seleziona canale",
    "mainSelectCountry": "Seleziona il paese",
    "mainSelectNumber": "Seleziona numero",
    "mainExpTimeInSec": "Tempo di scadenza in secondi",
    "mainExpTimeRequired": "Inserisci il tempo di scadenza",
    "mainFlowDesc": "Descrizione del flusso",
    "mainOtpLength": "Lunghezza OTP",
    "mainCancel": "Annulla",
    "mainTotalContacts": "Totale Contatti",
    "mainTotalUnits": "Unità Totali",
    "mainScheduledon": "Programmata il",
    "mainContactsBatch": "Num. contatti per invio",
    "mainTimeIntervalBatch": "Intervalli di tempo",
    "mainETACost": "Costo Stimato",
    "mainPrevious": "Indietro",
    "mainNoFund": "I fondi disponibili non sono sufficienti per lanciare questa campagna",
    "mainSelect": "Seleziona",
    "mainBack": "Indietro",
    "mainUsageLimit": "Il tuo limite di utilizzo verrà superato inviando questa campagna. Contatta il supporto all'indirizzo email support@tatacommunications per aumentare il limite, oppure riprova ancora utilizzando meno contatti",
    "mainType": "Tipologia",
    "mainLanguage": "Lingua",
    "mainTextMaxLimit": "Numero massimo di caratteri raggiunto",
    "mainBeta": "Beta",
    "mainSettings": "Impostazioni",
    "mainSupport": "Supporto",
    "mainIntegrationDirectory": "Integrazioni",
    "mainLogout": "Esci",
    "mainBalance": "Saldo",
    "mainUsage": "Credito",
    "mainAudioPreview": "Anteprima audio",
    "mainSearch": "Cerca",
    "mainLastUpdatedOn": "Ultimo aggiornamento il",
    "mainNoFlowYet": "Non hai ancora creato nessun flusso",
    "mainStartCreatingFlow": "Inizia a creare il tuo flusso con il nostro Flowbuilder, oppure utilizza uno dei nostri template",
    "conDescription": "Conversation",
    "conNoConHead": "Benvenuti in Conversation",
    "conNoconSubHead": "Personalizza la comunicazione con i tuoi clienti",
    "conNoconButtonLabel": "Inizia una nuova conversazione",
    "conNoChatHead": "Nessuna conversazione trovata!",
    "conNoChatSubHead": "Personalizza la comunicazione con i tuoi clienti",
    "conAddParameters": "Aggiungi Parametri al Template",
    "conNoConUserSelectedHead": "Seleziona una Conversazione",
    "verDescription": "Verify",
    "verOverview": "Panoramica",
    "verConfFLow": "Configura il Flusso di Verifica",
    "verWelcome": "Benvenuto in Verify",
    "verNoVerifyMsg": "Verifica i tuoi clienti con pochi semplici passi",
    "verNoVerifyButtonLabel": "Configura il Flusso di Verifica",
    "verSelectChannelMsg": "Imposta l'ordine che preferisci per i canali di verifica",
    "verSendThroughMsg": "Il messaggio verrà inviato tramite questo canale dopo l'intervallo di tempo impostato",
    "verSmsConfigure": "Configura gli SMS",
    "verSelectSenderId": "Seleziona Sender ID",
    "verSenderIdRequired": "Inserisci il Sender ID",
    "verSelectSmsTemplate": "Seleziona un template SMS",
    "verSmsTemplateRequired": "Inserisci un template SMS",
    "verEmailConfigure": "Configura le Email",
    "verDefineChannel": "Definisci le impostazioni per questo canale",
    "verTimeIntervalBtwChannel": "Intervallo di tempo tra i due canali",
    "verTiggerTimeRequired": "Inserisci un intervallo di tempo",
    "verTimeIntervalLimit": "Quest'intervallo di tempo deve essere minore del tempo di scadenza",
    "verTimeIntervalMaxLength": "La lunghezza massima è di 5 caratteri",
    "verTimeIntervalLessThanExpTime": "Quest'intervallo di tempo deve essere minore del tempo di scadenza e può essere al massimo 900",
    "verSuccessMsg": "Il flusso di verifica è stato configurato con successo.",
    "verConfVerFlow": "Configura il flusso di verifica",
    "verFlowNameRequired": "Inserisci il nome del flusso",
    "verFlowNameLimit": "Il nome del flusso può avere una lunghezza massima di 100 caratteri",
    "verFlowDescRequired": "Inserisci la descrizione del flusso",
    "verFlowDescLimit": "La descrizione del flusso può avere una lunghezza massima di 250 caratteri",
    "verOtpLenRequired": "Inserisci la lunghezza dell'OTP",
    "verOtpMinLen": "La lunghezza minima è 3",
    "verOtpMaxLen": "La lunghezza massima è 10",
    "verMakeDefault": "Vuoi impostarlo come predefinito?",
    "verAddNewChannel": "Aggiungi un altro canale",
    "verCreateATemplate": "Crea un Template",
    "verCreateANumber": "Acquista Numerazioni",
    "verCreateSenderId": "Richiedi un Sender ID",
    "verSenderIdToCompleteConfig": "Serve un Sender ID per configurare il flusso",
    "verSMSTemplateCompleteConfig": "Serve un Template SMS per configurare il flusso",
    "verNumberToCompleteConfig": "Serve un Numero per configurare il flusso",
    "verVoiceTemplateToCompleteConfig": "Serve un Template Voce per configurare il flusso",
    "verEmailTemplateToCompleteConfig": "Serve un Template Email per configurare il flusso",
    "temCreateTemplate": "Crea il primo template",
    "temAddNewTemplate": "Aggiungi Nuovo Template",
    "temTitleRequired": "Inserisci il titolo del template",
    "temTitleLengthLimit": "Il titolo può avere una lunghezza massima di 50 caratteri",
    "temChannelRequired": "Seleziona un Canale",
    "temEnterTemContents": "Inserisci il contenuto del template e includi {otp} come placeholder",
    "temContRequired": "Inserisci il testo del template",
    "temContLimit": "La lunghezza massima consentita per il testo del template è di 4000 caratteri",
    "temTitle": "Titolo del template",
    "temSearchBy": "Cerca per",
    "camSummary": "Riepilogo Campagne",
    "camTentativeMsg": "Costo stimato; il costo effettivo sarà calcolato dopo l'invio della campagna",
    "camNewBalance": "Il nuovo saldo dopo la campagna sarà",
    "camNewUsage": "La spesa totale dopo quest'invio sarà",
    "camLaunchACampaign": "Lancia una campagna ora",
    "camSelectCampaignType": "Seleziona la tipologia di campagna per procedere",
    "camLaunchVoice": "Inviare campagne Voce in tutto il mondo non è mai stato così semplice",
    "camLaunchSms": "Lancia una campagna SMS per raggiungere i tuoi clienti",
    "flowCreateNewFlow": "Crea un Nuovo Flusso",
    "flowCreateSubDescription": "Crea un flusso personalizzato o configuralo utilizzando un template di Kaleyra.",
    "flowExistingFlow": "Flussi esistenti",
    "mainPaused": "In pausa",
    "mainPublished": "Pubblicato",
    "mainDraft": "Bozza",
    "mainEdit": "Modifica",
    "mainRetrigger": "Rilancia richieste fallite",
    "mainResume": "Riattiva",
    "mainDelete": "Elimina",
    "mainPause": "Metti in Pausa",
    "mainAskForDelete": "Sei sicuro di voler eliminare il flusso",
    "mainAskForPause": "Sei sicuro di voler mettere in pausa il flusso",
    "mainAskForResume": "Sei sicuro di voler riattivare il flusso",
    "mainAskForEdit": "Sei sicuro di voler modificare il flusso",
    "mainYesDelete": "Sì, Elimina",
    "mainTrigger": "Trigger",
    "mainYesRetrigger": "Si, rilancia",
    "retriggeredCallbacks": "Richieste rilanciate con successo",
    "mainAuthor": "Autore",
    "mainTryThisTemplate": "Prova questo template",
    "mainDateModified": "Data di modifica",
    "mainWhatsapp": "WhatsApp",
    "mainSortBy": "Ordina per",
    "mainTemplates": "Templates",
    "mainCreateAnewFlow": "Crea senza template",
    "mainBlankFlowDescp": "Utilizza il flowbuilder per creare flussi personalizzati per tutti i tuoi canali.",
    "mainOopsNoFlow": "Non abbiamo trovato nessun flusso",
    "mainBlankFilteredFlow": "Inizia a creare il tuo flusso con il nostro Flowbuilder, oppure utilizza uno dei nostri template.",
    "mainOops": "Oops!",
    "mainNoActiveNmber": "Non hai attivato nessun numero. Acquista una numerazione idonea al servizio voce per iniziare a costruire il tuo flusso.",
    "mainViewAllFlows": "Visualizza tutti i flussi",
    "mainViewAllTemplates": "Visualizza tutti i template",
    "mainSubscribeNumbers": "Acquista Numerazioni",
    "mainShowing": "Visualizzati",
    "mainOf": "di",
    "mainAll": "Tutti",
    "mainFilterPublished": "Pubblicati",
    "flwHead": "Configura Verify",
    "flwStepMain": "Configurazione canali",
    "flwStepTwo": "Salva configurazione",
    "flwChnHead": "Aggiungi il primo canale",
    "flwConfName": "Nome della Verifica",
    "flwOtpLen": "Lunghezza OTP",
    "flwOtpType": "Tipologia OTP",
    "flwInterval": "Intervallo di tempo tra i canali",
    "flwExpTime": "Intervallo di validità",
    "flwDefault": "Imposta questa configurazione come predefinita",
    "flwConsent": "Consenti l'utilizzo di un altro Sender ID in caso di problemi",
    "flwPublish": "Pubblica",
    "flwOtpTypeNumeric": "Numerico",
    "flwOtpTypeAlphanumeric": "Alfanumerico",
    "flwIntervalRequired": "Inserisci l'intervallo di tempo",
    "flwIntervalValidation": "È consigliato impostare l'intervallo di tempo tra i 60 e i 900 secondi",
    "flwExpTimeValidation": "Expiry time is not valid",
    "flwExpTimeMin": "Expiry time needs to be greater than",
    "flwExpTimeMinVal": "to support the interval specified",
    "flwSelTmp": "Template Selezionato",
    "flwMailFrom": "Da",
    "flwMoveUp": "Sposta in alto",
    "flwMoveDown": "Sposta in basso",
    "flwNext": "Avanti",
    "flwChn1": "Primo",
    "flwChn2": "Secondo",
    "flwChn3": "Terzo",
    "flwInterval1": "Imposta l'intervallo di tempo tra i due canali",
    "flwInterval2": "e il canale",
    "flwSending": "Invio",
    "flwNumber": "Numero",
    "flwTemplate": "Template",
    "flwMailID": "Email ID",
    "flwAdd": "Aggiungi",
    "flwExpMaxVal": "L'intervallo di validità deve essere minore di 10.800 secondi",
    "mainSpeechRate": "Velocità del parlato",
    "verifyEmptyTemplate": "Non hai ancora creato nessun template.",
    "verifyEmptyTemplateDesc": "Clicca su “Crea Template” per aggiungere un template SMS, Voce o Email",
    "verifyAddTemplates": "Crea template",
    "verifyAddNewTemplate": "Aggiungi nuovo template",
    "verifyTemplateName": "Nome del template",
    "verifyFromEmail": "Email di provenienza",
    "verifyEmailSubject": "Oggetto dell'email",
    "verifyEnterTemplateContent": "Inserisci il contenuto del template e l'OTP",
    "verifyOTPVariableMandatory": "E' obbligatorio inserire la variabile OTP come {OTP}",
    "verifyValidEmail": "Inserisci un indirizzo email valido",
    "verifySenderID": "Sender ID",
    "verifyEntityId": "Entity ID",
    "verifyTemplateId": "Template ID",
    "verifyTemplateNameMinMax": "Il Nome deve contenere dai 3 ai 40 caratteri",
    "verifyOnlyNumbers12to19": "L'ID deve contenere tra le 12 e le 19 cifre",
    "verifyConfirmation": "Conferma",
    "verifyCancelConfirmation": "Sei sicuro di voler annullare la creazione del template?",
    "verifyEnableConfirmation":"Vuoi abilitare il profilo?",
    "verifyDisableConfirmation":"Vuoi disabilitare il profilo?",
    "mainDontCancel": "No, non annullare",
    "mainYesCancel": "Sì, annulla",
    "mainEnableCancel":"Cancel",
    "verifyConfigId": "ID configurazione",
    "configAddConFiguration": "Aggiungi Configurazione",
    "configTest": "Test",
    "kaleyraVerify": "Kaleyra Verify",
    "keleyraVerifyDesc": "Proteggi i tuoi clienti dalle frodi utilizzando le One Time Password (OTP). Sono facilmente configurabili su SMS, email e voce",
    "verifyCreateConfig": "Crea una configurazione di Verify",
    "mainUnderVerification": "In fase di verifica",
    "verifyPauseConfig": "Sei sicuro di voler mettere in pausa la configurazione?",
    "verifyDeleteConfig": "Sei sicuro di voler eliminare la configurazione?",
    "verifyResumeConfig": "Sei sicuro di voler riprendere la configurazione?",
    "mainDontPause": "No, non mettere in pausa",
    "mainYesPause": "Sì, metti in pausa",
    "mainDontDelete": "Non eliminare",
    "mainDontResume": "No, non riprendere",
    "mainYesResume": "Sì, riprendi",
    "mainCopiedToClipboard": "Copiato negli appunti",
    "mainNoResultsFound": "Nessun risultato trovato",
    "mainTrySearchingDiffTerm": "Prova a cercare un'altra parola",
    "mainOr": "o",
    "mainClearSearch": "Annulla la ricerca",
    "chatbotMenu": "Chatbot",
    "callbacksMenu": "Callbacks",
    "callbacksLogs": "Callbacks Logs",
    "callbacksProfiles": "Callbacks Profiles",
    "chatbotHeader": "Chatbot",
    "chatbotSubtext": "Raggiungi i tuoi clienti tramite un Chatbot personalizzato",
    "chatbotReqbutton": "Richiedi ora",
    "chatbotStatusPending": "In attesa",
    "chatbotStatusSucess": "Attivo",
    "chatbotSubmited": "La tua richiesta per 'Chatbot' è stata inviata",
    "chatbotSubmitedText": "Il nostro Servizio Clienti ti contatterà per maggiori informazioni.",
    "chatbotViewDetails": "Visualizza le informazioni inviate",
    "chatbotRequest": "Richiedi un Chatbot",
    "chatbotBotname": "Nome Bot",
    "chatbotBotLanguage": "Lingua predefinita del Bot",
    "chatbotBotType": "Tipologia di bot",
    "chatbotDocuments": "Documenti a supporto o URLs",
    "chatbotUplodDocs": "Carica i Documenti",
    "chatbotUplodText": "Trascina e rilascia i documenti qui o Clicca qui per caricarli",
    "chatbotOr": "o",
    "chatbotUrl": "L'URL",
    "chatbotCancel": "Annulla",
    "chatbotAddurl": "Aggiungi un'altra URL",
    "chatbotSubmit": "Invia",
    "chatbotRequestSubmit": "Richiesta inviata",
    "chatbotRequestsubmitText": "La tua richiesta per un Chatbot è stata inviata correttamente. Il nostro Servizio Clienti ti contatterà quanto prima.",
    "chatbotOkay": "OK",
    "chatbotSupportURL": "URL del link",
    "chatbotSupportDocs": "Documenti a supporto",
    "chatbotDetails": "Informazioni del Bot",
    "chatbotFilessupports": "I formati di file supportati sono: jpeg\/jpg\/pdf\/doc\/docx",
    "chatbotUrlerror": "L'URL deve includere http, https o ftp.",
    "rbmTitle": "Rich Business Messaging",
    "rbmTitleInfo": "Gli RBM ti aiutano a garantire affidabilità al tuo brand e ti permettono di inviare SMS multimediali e migliorare le metriche",
    "rbmSenderId": "Seleziona Sender ID",
    "rbmDisplayname": "Display Name",
    "rbmDisplaynameInfo": "Il display name è visibile quando gli utenti interagiscono con il tuo Agent. Può contenere massimo 40 caratteri.",
    "rbmDesc": "Descrizione (facoltativa)",
    "rbmDesclimit": "Massimo 100 caratteri",
    "rbmPrimarysite": "Sito Web",
    "rbmLabelforsite": "Etichetta per il sito web",
    "rbmSitelimit": "Massimo 25 caratteri",
    "rbmPrimaryemail": "Indirizzo email",
    "rbmEmaillabel": "Etichetta per l'email",
    "rbmPrivacyurl": "URL dell'Informativa Privacy",
    "rbmServiceUrl": "URL delle Condizioni del Servizio",
    "rbmColor": "Colore",
    "rbmColorinfo": "Scegli un colore per il tuo Agent; il colore deve avere un rapporto di contrastodi almeno 4,5:1 rispetto al bianco.",
    "rbmLearnMore": "Scopri di più",
    "rbmColorindosub": "sul rapporto di contrasto",
    "rbmColorcode": "Codice colore",
    "rbmImages": "Immagini",
    "rbmImagesinfo": "Scegli delle immagini per il tuo Agent. L'immagine del banner apparirà quando un utente visualizza le informazioni sulla tua attività, mentre il logo viene visualizzato quando l'Agent invia un messaggio a un utente.",
    "rbmBannerimage": "Immagine del banner",
    "rbmBannerimageinfo": "L'immagine deve essere un JPEG di 1440x448 px e con un peso inferiore a 200KB",
    "rbmSmallLogo": "Logo",
    "rbmSmalllogoINfo": "L'immagine deve essere di 224x224 px e inferiore a 50KB. Assicurati che il logo si veda bene in un cerchio.",
    "rbmHostingregion": "Zona di hosting",
    "rbmHostingInfo": "Gli Agent RBM possono essere in una delle tre aree. Quest'impostazione non potrà più essere cambiata.",
    "rbmSelectRegion": "Seleziona la Regione di Hosting",
    "rbmAgreeTerms": "Accetto ",
    "rbmTerms": "le Condizioni di Servizio.",
    "rbmSubmitRequest": "Invia richiesta",
    "rbmPrimaryPhone": "Numero di telefono",
    "mainCountry": "Nazione",
    "verifyCancelChannel": "Sei sicuro di voler annullare la configurazione del canale?",
    "flwDelChannel": "Are you sure you want to delete this channel?",
    "flwRedirect": "All configuration changes will not be saved. Are you sure you want to cancel?",
    "flwEmptyTextMain": "Non hai ancora creato un template",
    "flwEmptyTextSub": "Crea un template cliccando su 'Crea Template'",
    "flwSelectedChn": "Canali selezionati",
    "camLaunchCampaign": "Lancia una Campagna",
    "camCreatedOn": "Creata il",
    "camInProcess": "In corso",
    "mainFailed": "Fallita",
    "mainCompleted": "Completata",
    "mainScheduled": "Programmata",
    "mainTargeted": "Destinatari",
    "mainLastUpdated": "Ultimo aggiornamento",
    "camCampaignName": "Nome della Campagna",
    "camLaunchYourFirstCampaign": "Lancia la tua prima campagna",
    "camGoMakeSomeNoise": "Fai sentire la tua voce!",
    "camCreateCampaign": "Crea una Campagna",
    "mainRegular": "Standard",
    "camComposeMessage": "Crea il messaggio",
    "camReviewandPublish": "Controlla e Invia",
    "camCamNameRequired": "È necessario dare un nome alla Campagna",
    "mainPlace": "Località",
    "mainTags": "Tag",
    "mainCreated": "Creato il",
    "camDownloadSampleFile": "Scarica un esempio di file",
    "camDragnDropCSV": "Trascina e rilascia qui il file Excel o CSV",
    "camClickToUpload": "Clicca qui per caricarli",
    "mainImport": "Importa",
    "mainFileUploadSuccess": "Il file è stato caricato con successo",
    "cam6ColmnFound": "6 Colonne trovate",
    "cam30000ContactFound": "30,000 Contatti trovati",
    "cam20DuplicateContactsRemoved": "20 Contatti doppi eliminati",
    "cam1InvalidContactRemoved": "1 Contatto non valido eliminato",
    "mainMobileNumber": "Numero di Cellulare",
    "mainColmnRequired": "È necessario indicare una colonna",
    "camDoesntIncludeCountryCode": "Non include il Prefisso Internazionale?",
    "camCountryCodeRequired": "È necessario il prefissio internazionale",
    "mainSearchForContacts": "Cerca per contatto",
    "mainFilter": "Filtri",
    "mainClearFilter": "Rimuovi i filtri",
    "mainIncludeCountryCode": "Aggiungi il prefisso internazionale",
    "mainCountryCode": "Prefisso internazionale",
    "camOneMsgToAll": "Un messaggio per tutti i contatti",
    "mainCamLength3to40": "La lunghezza dev'essere tra i 3 e 40 caratteri",
    "mainCamAlphanumericAllowed": "Sono permessi solo caratteri alfanumerici",
    "mainCamType": "Tipologia di Campagna",
    "camCustomizedSoon": "Personalizzata (a breve)",
    "camMsgCanbeCustomized": "I messaggi possono essere personalizzati per cliente",
    "mainImportContacts": "Importa Contatti",
    "mainImportFromDirectory": "Importa da Rubrica",
    "mainCopyPasteNos": "Copia & Incolla i Numeri",
    "mainContactsImported": "Contatti importati",
    "mainInvalidContactFound": "Contatti non validi trovati",
    "mainDuplicateContactsFound": "Contatti duplicati trovati",
    "mainUploadAtLeastOneContact": "Carica almeno un contatto per continuare!",
    "mainCopyPasteContacts": "Copia & Incolla i Numeri",
    "mainUploadCSVorExcel": "Carica un file Excel o CSV",
    "mainSelectAll": "Seleziona tutto",
    "mainSelected": "Selezionati",
    "mainContact": "Contatto",
    "camTimeIntervelRequired": "Un intervallo di tempo è obbligatorio",
    "camScheduleTimeShouldBe": "L'orario di invio non può essere prima di 15 minuti da ora",
    "camSelectSoundFileToProceed": "Scegli un file audio per continuare",
    "camTextToSpeech": "Text-to-speech",
    "mainSelectAudio": "Audio",
    "mainUploadFile": "Carica File",
    "mainNoOfRetires": "Tentativi successivi",
    "camNoOfRetiresRequired": "Tentativi successivi è un campo obbligatorio",
    "camSendThisCampaign": "Invia questa Campagna",
    "mainNow": "Ora",
    "mainLater": "Più tardi",
    "mainDateRequired": "È richiesta una data",
    "mainScheduleTimeRequired": "Indicare l'orario programmato",
    "mainSplitCampaignSchedule": "Programma Invii Multipli",
    "camBacthNoRequired": "Inserisci il numero di lotti",
    "camMinSizeShouldbe1k": "Il numero minimo è 1000",
    "camBatchSizeShouldbeLessThan": "Il lotto potrebbe avere meno del numero minimo di contatti",
    "camTimeIntervalInMin": "Intervallo di tempo (in minuti)",
    "mainBrowserSupportAudio": "Il tuo browser non supporta questa traccia audio",
    "camSpeechRateRequired": "La velocità di riproduzione è obbligatoria",
    "mainLanguageRequired": "Il campo Lingua è obbligatorio",
    "mainMsgRequired": "Il messaggio è obbligatorio",
    "mainPleaseReduceNoOfChar": "Il testo è troppo lungo - Può contenere al massimo 2900 caratteri.",
    "mainPreview": "Anteprima",
    "camSoundTitleRequired": "Inserisci il nome del file audio",
    "camDragnDropMp3": "Trascina e rilascia i file mp3 qui",
    "mainFile": "File",
    "mainDuration": "Durata",
    "flwStepTwoDesc": "Please confirm the advanced settings for your configuration before publishing",
    "optInLabel": "Impostazioni di Opt-in",
    "optOutLabel": "Impostazioni di Opt-out",
    "optDesc": "Consenti agli utenti di scegliere se ricevere o meno gli SMS, nel rispetto delle leggi a riguardo.",
    "optInformationIn": "Puoi inserire fino a 20 keyword, separate da una virgola; la keyword 'START' non può essere eliminata.",
    "optInformationOut": "Puoi inserire fino a 20 keyword, separate da una virgola; la keyword 'STOP' non può essere eliminata.",
    "optInKeyword": "Opt-in keywords",
    "optOutKeyword": "Opt-out keywords",
    "optKeyPlaceholder": "Inserisci keyword",
    "optInConfirm": "Invio conferma opt-in",
    "optOutConfirm": "Invio conferma opt-out",
    "optOption": "Reimposta al template di default",
    "optTagInfo": "Questa keyword non può essere eliminata",
    "optStart": "START",
    "optSTOP": "STOP",
    "optDefaultOptinName": "Template opt-in di default",
    "optDefaultOptoutName": "Template opt-out di default",
    "optDefaultOptinContent": "Hai scelto di ricevere messaggi da questo numero; Invia un messaggio con testo STOP per annullarli.",
    "optDefaultOptoutContent": "Hai annullato la ricezione di messaggi da questo numero, invia un messaggio con testo START per riattivarli.",
    "mainRemove": "Rimuovi",
    "tabConfigurations": "Configurazioni",
    "tabVerifiedSMS": "Verified SMS",
    "optCancel": "Sei sicuro di voler annullare le modifiche?",
    "optSender": "Same Sender",
    "chaCompleteKyc": "Completa il KYC",
    "chaCompleteKycDesc": "Stai utilizzando una versione di prova. Per richiedere l'accesso a questo canale, inserisci i dati della tua azienda.",
    "chaPendingKyc": "KYC in fase di verifica",
    "chaPendingKycDesc": "Il tuo KYC è in fase di verifica. Potrai richiedere l'accesso a questo canale una volta che avremo verificato con successo i tuoi dati aziendali.",
    "chaNotApproved": "KYC non approvato",
    "chaNotApprovedKycDesc": "Per richiedere l'accesso a questo canale, aggiorna i dati della tua azienda.",
    "chaUpdateKyc": "Aggiorna KYC",
    "mainManage": "Gestisci",
    "mainRequestAccess": "Richiedi l'accesso",
    "mainResubmitRequest": "Reinvia Richiesta",
    "mainViewStatus": "Vedi Stato",
    "mainPricing": "Prezzi",
    "mainInActive": "Non attiva",
    "chaSmsPricing": "Prezzi SMS",
    "chaVoicePricing": "Prezzi Voce",
    "chaMoreDetailsVisit": "Per maggiori dettagli, visita il",
    "chaMarketingWebsite": "nostro sito",
    "chaPerSms": "SMS",
    "chaPerOtp": "OTP",
    "mainCustomPrice": "Prezzo Custom",
    "chaYouCanSend": "Puoi inviare",
    "chaMsgWithUrBalance": "messaggi con il saldo disponibile",
    "chaPlacingAcall": "Effettuare una chiamata",
    "chaStartsAt": "A partire da",
    "chaPerMinFor": "al min verso ",
    "chaPerMinForAllCalls": "al min per",
    "chaAllCalls": "Tutte le Chiamate",
    "chaReceivingAcall": "Ricevere una chiamata",
    "chaTryDemo": "Prova Demo",
    "mainPlans": "Piani",
    "chaRbmPricing": "Prezzi RBM",
    "chaLocalCall": "Rete Fissa",
    "mainMobileCall": "Cellulari",
    "chaTollFreeCall": "Numeri Verdi",
    "chaEmptyPricing": "Qualcosa è andato storto. Si prega di riprovare più tardi.",
    "chaForMoreDetails": "Per maggiori dettagli",
    "kycTrialVersion": "Questa è una versione di prova, per ottenere il pieno accesso",
    "kycCompleteUrKyc": "Completa il tuo KYC",
    "mainClickHere": "Clicca qui",
    "kycToLearnMore": "per saperne di più",
    "kycFailed": "La verifica del tuo KYC non è andata a buon fine!",
    "kycPending": "Il tuo KYC è in fase di verifica",
    "waYouMightbeCharged": "Ti potrebbe essere addebitato un importo minimo per questa transazione",
    "mainToPhoneNumber": "A Numero di Telefono",
    "mainTemplateBody": "Template Body",
    "mainBookingConfirmed": "Booking Confirmed",
    "mainOrderDelivered": "Order Delivered",
    "mainMessageSent": "Messaggio Inviato",
    "chaYourMsgTo": "Il tuo messaggio al numero",
    "chaHasBeenSent": "è stato inviato con successo",
    "mainMsgCost": "Costo del messaggio ",
    "provideParameter1": "Inserisci il Parametro 1 per procedere",
    "provideParameter2": "Inserisci il Parametro 2 per procedere",
    "provideValidToPhoneNumber": "Inserisci un numero di telefono valido",
    "whatsappAccStatus": "Stato dell'account Whatsapp",
    "kycRetryKyc": "Reinvia il KYC",
    "rbmPhoneabel": "Etichetta per il numero di telefono",
    "chaPerMsg": "Messaggio",
    "chaAllOtherCalls": "Tutte le Altre Chiamate",
    "chaSmsDesc": "Inviare campagne SMS in tutto il mondo non è mai stato così semplice",
    "chaVoiceDesc": "Inviare campagne Voce in tutto il mondo non è mai stato così semplice",
    "chaEmailDesc": "Coinvolgi i clienti con esperienze mobili personalizzate e interattive sull'app di messaggistica predefinita",
    "chaWhatsappDesc": "Raggiungi i tuoi clienti oggi stesso con l'account WhatsApp for Business",
    "chaGoogleDesc": "Coinvolgi i tuoi clienti grazie a un'esperienza mobile interattiva sull'app di messaggistica predefinita",
    "chatbotUrlplaceholder": "Inserisci l'URL",
    "chatbotUrlmax": "Massimo 255 caratteri",
    "charbotDisplayMax": "Massimo 50 caratteri",
    "mainPer": "per",
    "rbmSiteUrlerror": "L'URL non è valido",
    "rbmmaxSite": "Massimo 255 caratteri (incluso https:\/\/)",
    "mainViewRequest": "Visualizza Richiesta",
    "prcSelBasedOnKYC": "I piani e le tariffe indicate potrebbero cambiare in base al tuo Paese di fatturazione.",
    "completKYCtoViewPlan": "Completa il KYC per visualizzare i piani disponibili nella tua regione.",
    "excOutMsgNotice": "* Una volta superato il limite, sarai addebitato in base al piano Pay-As-You-Go. Solo il piano Starter, non consente più l'invio di messaggi una volta superato il limite.",
    "whatsappTempMsg": "In generale, il costo di un messaggio template è composto da una tariffa di WhatsApp ed una di Kaleyra. Tuttavia, in base al tuo piano e ad altri parametri quali la nazione di destinazione dei messaggi, potrebbero esserti addebitate solo una o nessuna delle due tariffe sotto indicate.",
    "additionalContactSupp": "Per maggiori info sui prezzi, contatta il nostro team di supporto.",
    "payAsYouGo": "Pay-as-you-go",
    "whaNotVerInfo": "Una volta attivato il tuo account WhatsApp ti verrà assegnato il piano a consumo Pay-as-you-go. Potrai cambiare piano in qualsiasi momento.",
    "whatsappPlans": "Piani WhatsApp",
    "whatsappPlan": "Piano WhatsApp",
    "monthly": "Mensile",
    "yearly": "Annuale",
    "perMsg": "\/messaggio",
    "swiToPAYG": "Passa al piano Pay-as-you-go",
    "swiPlan": "Cambia piano",
    "downgradeText": "se desideri annullare o eseguire il downgrade del tuo abbonamento.",
    "buyPlan": "Acquista il Piano",
    "tdCharge": "Importo addebitato",
    "usageMonthly": "Utilizzo mensile dopo il pagamento",
    "avlBal": "Saldo disponibile dopo pagamento",
    "noSuffBal": "Non disponi di fondi sufficienti per acquistare il piano. Aggiungi credito al tuo account.",
    "rchNow": "Ricarica ora",
    "cnf": "Conferma",
    "requestContact": "Se stai inviando una una richiesta di piano Enterprise, ti contatteremo quanto prima.",
    "reqSent": "Richiesta inviata. Verrai contattato quanto prima dal nostro team.",
    "custom": "Personalizzato",
    "ibsm": "Messaggi di Sessione in entrata",
    "obsm": "Messaggi di Sessione in uscita per mese*",
    "obsmC": "Messaggi di Sessione in uscita per mese",
    "tmpAvl": "Templates disponibili",
    "obtm": "Messaggi Template in uscita per mese",
    "suppPhoneNo": "Numeri di telefono supportati",
    "custSupp": "Servizio clienti",
    "custCare": "Contatta il servizio clienti ",
    "tmpNotCost": "Costo di invio messaggi Template",
    "excTmpCost": "Costo di invio messaggi template (oltre il limite incluso)",
    "ibsmTltp": "Numero massimo di messaggi ricevibili dai clienti",
    "obsmTltp": "Numero massimo di risposte che possono essere inviate ai clienti",
    "tmpAvlTltp": "Numero massimo di template che ciascun account può creare",
    "obtmTltp": "Numero massimo di messaggi Template inviabili ai clienti",
    "suppPhoneNoTltp": "Numeri di telefono attivabili per account",
    "tmpMsgDelCost": "Costo di invio messaggi template",
    "klrFee": "Tariffa Kaleyra",
    "whaFee": "Tariffa WhatsApp ",
    "excTmpCostTltp": "Ti verranno addebitate queste tariffe se superi il numero massimo di messaggi Template inclusi nel tuo piano. Solamente per il piano Starter, dovrai attendere la fine del mese oppure effettuare l'upgrade per inviare altri messaggi Template.",
    "payAsYouGoPart1Int": "I messaggi di sessione in entrata ed in uscita hanno un costo di {{curCode}} {{inbC}} in tutto il mondo, mentre verranno applicate le tariffe WhatsApp e Kaleyra sopra indicate per l'invio dei messaggi Template. Avrai a disposizione {{tmpC}} template di e {{phoneNo}} numero di telefono. ",
    "payAsYouGoPart1Ind": "I messaggi di sessione in entrata ed in uscita verso l'India hanno un costo di {{curCode}} {{inbC}} ({{outbC}} {{curCode}} per i messaggi di Sessione verso altre Nazioni). Verranno applicate le tariffe WhatsApp e Kaleyra sopra indicate per l'invio dei messaggi Template, e avrai a disposizione {{tmpC}} template di e {{phoneNo}} numero di telefono.",
    "payAsYouGoPart2Int": "Stai utilizzando il piano a consumo Pay-as-you-go. I messaggi di sessione in entrata ed in uscita hanno un costo di {{curCode}} {{inbC}} in tutto il mondo, mentre verranno applicate le tariffe WhatsApp e Kaleyra sotto indicate per l'invio dei messaggi Template. Hai a disposizione {{tmpC}} template di e {{phoneNo}} numero di telefono.",
    "payAsYouGoPart2Ind": "Stai utilizzando il piano a consumo Pay-as-you-go. I messaggi di sessione in entrata ed in uscita verso l'India hanno un costo di {{curCode}} {{inbC}} ({{outbC}} {{curCode}} per i messaggi di Sessione verso altre Nazioni). Verranno applicate le tariffe WhatsApp e Kaleyra sotto indicate per l'invio dei messaggi Template, e hai a disposizione {{tmpC}} template di e {{phoneNo}} numero di telefono.",
    "payAsYouGoPart3Int": "Se desideri annullare il tuo attuale abbonamento puoi passare al piano Pay-as-you-go verrai addebitato in base al consumo. I messaggi di sessione in entrata ed in uscita hanno un costo di {{curCode}} {{inbC}} in tutto il mondo, mentre verranno applicate le tariffe WhatsApp e Kaleyra sopra indicate per l'invio dei messaggi Template. Avrai a disposizione {{tmpC}} template di e {{phoneNo}} numero di telefono.",
    "payAsYouGoPart3Ind": "Se desideri annullare il tuo attuale abbonamento puoi passare al piano Pay-as-you-go verrai addebitato in base al consumo. I messaggi di sessione in entrata ed in uscita verso l'India hanno un costo di {{curCode}} {{inbC}} ({{outbC}} {{curCode}} per i messaggi di Sessione verso altre Nazioni). Verranno applicate le tariffe WhatsApp e Kaleyra sopra indicate per l'invio dei messaggi Template, e avrai a disposizione {{tmpC}} template di e {{phoneNo}} numero di telefono.",
    "buyPlanText1": "Potrai usufruire del piano {{name}} una volta effettuato il pagamento.",
    "buyPlanText2": "Ti verrà addebitato mensilmente l'importo di {{val}}{{cur}} a partire dalla data di acquisto.",
    "buyPlanPre": "We highly suggest for you to enable the auto-debit, so that you will never run out of balance.",
    "actPl": "piano attivo",
    "perInbSesMsg": "per messaggi di Sessione in entrata",
    "perOutbSesMsg": "per messaggi di Sessione in uscita",
    "rbmAddnew": "Inserisci Nuovo",
    "rbmSubmitMessage": "La tua richiesta di accesso al servizio Rich Business Messaging è stata inviata correttamente. Il nostro Servizio Clienti ti contatterà al più presto. ",
    "rbmOnlyimage": "Tipi di file supportati: JPEG\/JPG",
    "rbmInvaidHex": "Codice colore non valido, inserisci un codice esadecimale valido",
    "rbmAddSenderid": "Aggiungi un SederID",
    "rbmNoSenderid": "Non ci sono SenderID disponibili. ",
    "rbmFilesizeError": "Le dimensioni del file devono essere inferiori di ",
    "fbTemplates": "template",
    "chWhPlan": "Scegli un piano WhatsApp",
    "talktoUs": "Contattaci",
    "youBeCharge": "Ti verranno addebitati {{prc}} il {{ren_dt}}",
    "prchsuccess": "Acquisto riuscito",
    "prmSupp": "Supporto Premium",
    "exportLogs": "Esporta",
    "callFrom": "Chiamata da",
    "callTo": "Chiama",
    "bridgeNumber": "Bridge Number",
    "callStatus": "Stato chiamata",
    "billSeconds": "Secondi fatturati",
    "creditsUtilized": "Costo",
    "prmSuppTltp": "-Account Manager dedicato per il supporto in varie attività quali onboarding e processo di verifica dell'account WhatsApp. \/- SLAs",
    "contactSupport": "Contatta il servizio clienti",
    "downGrade": "Downgrade",
    "requestHead": "Richiedi un piano Enterprise",
    "performanceWidget": "Performance",
    "performanceWidgetManageSenderId": "Gestisci senderID",
    "performanceWidgetTotalMessages": "Totale messaggi",
    "performanceWidgetAvgDelivery": "Percentuale media di consegnato",
    "performanceWidgetAvgDeliveryTime": "Tempo medio di consegna",
    "performanceWidgetSMSDeliveryLatency": "Tempo medio di latenza di un SMS",
    "performanceWidgetSenderId": "Mittente",
    "templateMsgLimitExc": "per l'invio di messaggi template (oltre il limite incluso)",
    "outboundMLimitExec": "per l'invio di messaggi di sessione in uscita (oltre il limite incluso)",
    "outboundMLimitInd": "per outbound Session message sent to India",
    "outboundMLimitIndExec": "per outbound Session message sent outside of India",
    "assetsWidget": "Assets",
    "assetsWidgetWaNumbers": "Numeri WhatsApp",
    "assetsWidgetSmsTemplate": "Template SMS",
    "assetsWidgetWhatsappTemplate": "Template WhatsApp",
    "assetsWidgetKycDocs": "Documenti",
    "assetsWidgetTemplateTitle": "Titolo del template",
    "assetsWidgetPurpose": "Scopo",
    "assetsWidgetNumber": "Numerazioni",
    "assetsWidgetNextBillingDate": "Prossimo Pagamento",
    "assetsWidgetDisplayName": "Display Name",
    "assetsWidgetTemplateName": "Template Name",
    "assetsWidgetCategory": "Categoria",
    "assetsWidgetLanguage": "Lingua",
    "assetsWidgetId": "ID",
    "assetsWidgetDocument": "documento",
    "assetsWidgetUploadDate": "Data di caricamento",
    "assetsWidgetRequestedDate": "Richiesto il",
    "assetsWidgetStatus": "Stato",
    "assetsWidgetHeaderSenderId": "SMS Sender ID",
    "assetsWidgetHeaderDidNumbers": "Numerazioni DID",
    "assetsWidgetHeaderWaNumbers": "Numeri WhatsApp",
    "assetsWidgetHeaderSmsTemplate": "Template SMS",
    "assetsWidgetHeaderWhatsappTemplate": "Template WhatsApp",
    "assetsWidgetHeaderKycDocs": "Documenti",
    "orgName": "Nome dell'Organizzazione",
    "requestReport": "Richiedi Report",
    "reportTitle": "Inserisci il nome del brand",
    "fromDate": "Da",
    "toDate": "A",
    "googleSignin": "Continua con Google",
    "verifyEmailRightTitle": "Hai appena usato il nostro servizio di VERIFY tramite email!",
    "verifyEmailRightText": "Il servizio di verifica dell'email che hai appena utilizzato si chiama VERIFY ed è fornito da Kaleyra. Completa la registrazione per provarlo tu stesso!",
    "verifyEmailHead": "Verifica la tua Email",
    "verifyEmailSub1": "Abbiamo inviato un'email a",
    "verifyEmailSub2": "con un link per attivare il tuo account",
    "verifyEmailQ": "Non hai ricevuto l'email?",
    "verifyEmailSol": "Controlla la cartella dello spam. Assicurati che l'indirizzo email inserito sia corretto e che non ci siano firewall o filtri che ne impediscano la ricezione.",
    "verifyEmailBtn": "Aggiorna Email e Reinvia",
    "resendMailHead": "Reinvia l'Email di Verifica",
    "resendMailSub": " Se non hai ricevuto l'email, puoi richiedere un nuovo invio sullo stesso o su un nuovo indirizzo email.",
    "verifySent": "Verification Send",
    "verifySentSub": "We sent you an email with activation link to",
    "returnLogin": "Ritorna al Login",
    "welcomeHead": "Benvenuto su Kaleyra",
    "welcomeSub": "Ti abbiamo assegnato dei crediti :credits gratuiti per testare la nostra piattaforma. Come vorresti inziare?",
    "welcomeFoot1": "Durante il periodo di prova hai un accesso limitato ai nostri servizi.",
    "welcomeFoot2": "Inserisci i dettagli dell'azienda",
    "welcomeOpt1": "Testa le nostre API",
    "welcomeOpt2": "Lancia una Campagna",
    "passwordValidation": "La password deve contenere almeno",
    "signUpTrouble": "Problemi con la registrazione?",
    "firstName": "Nome",
    "lastName": "Cognome",
    "businessMail": "Email Aziendale",
    "password": "Password",
    "signCheck": "Accetto le",
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "and": "and",
    "signInCheck": "Autorizzo il trattamento dei miei dati per finalità di marketing per ricevere informazioni commerciali sui prodotti e servizi di Kaleyra, anche via email, contatti telefonici e con modalità automatizzate.",
    "register": "Crea account",
    "signQuestion": "Hai già un account?",
    "login": "Login",
    "smsCard": "Manda messaggi SMS in tutto il mondo e interagisci con i tuoi clienti con un tocco umano.",
    "waCard": "Utilizza Whatsapp per iniziare conversazioni in tempo reale e inviare media.",
    "voiceCard": "Centralino cloud, funzionalità di `click to call` e inoltro delle chiamate.",
    "verifyCard": "Autenticazione di utenti e validazione di transazioni tramite one time password.",
    "trustCard": "Utilizzato da",
    "more": "e altri",
    "accountSetUpNote": "While in trial mode, you can only send messages to phone numbers you've verified with Kaleyra.",
    "accountSetUpHead": "Tell us a bit about your company and verify your phone number to start using our product.",
    "accountSetUpHeader": "Few things to set up your account",
    "rightTemplateHeader1": "SMS Verification, powered by Kaleyra",
    "rightTemplateText1": "Did you know that Verify delivers 98% of the OTP authentication messages within 5 seconds?",
    "rightTemplateText2": "The SMS verification service you are going to use is called VERIFY. Your phone number will be validated using a platform-generated OTP.",
    "phoneNumber": "Phone Number",
    "verifyNumber": "Verify Your Number",
    "firstNameRequired": "Inserisci il tuo nome",
    "lastNameRequired": "Inserisci il tuo cognom",
    "passRequired": "Inserisci una password",
    "termsRequired": "Please agree to the Terms of Service",
    "passValid": "Password Validation",
    "frstNameLimit": "Il nome non può contenere più di 50 caratteri",
    "lastNameLimit": "Il cognome non può contenere più di 50 caratteri",
    "hi": "Ciao",
    "minimum8Charcter": "8 caratteri",
    "minimumOneUppercase": "Una lettera maiuscola",
    "minimumOneLowercase": "Una lettera minuscola",
    "minimumOneNumber": "Un numero",
    "minimumOneSpecialCharacter": "Un simbolo",
    "apiKeys": "API Keys",
    "generateApiKeys": "Crea API Key",
    "keyNeverUsed": "mai usato",
    "apikeysSection": "Apikeys section",
    "mainHistory": "Fatture",
    "dateHeader": "Data",
    "mainTotInclTax": "Totale (IVA inclusa)",
    "mainTotExclTax": "Totale (IVA esclusa)",
    "paymentMethod": "Metodo di Pagamento",
    "mainDownload": "Scarica",
    "mainService": "Service",
    "mainActivity": "Activity",
    "document": "Rete di PortabilitÃ",
    "uploadNewDocument": "Carica nuovo documento",
    "size": "Stato di PortabilitÃ",
    "uploaded": "Il documento Ã¨",
    "uploadDocuments": "Trascina e rilascia i documenti qui",
    "inviteMembers": "Invite Member",
    "inviteMemTitle": "Invita i membri del tuo team",
    "sendInvite": "Send Invitation",
    "addSoundFile": "Aggiungi File Audio",
    "Filters": "Filtri",
    "BLD00084": "Rimuovi filtri",
    "BLD00278": "Scarica",
    "id": "Id",
    "apply": "Applica",
    "BLD01036": "Applica",
    "BLD00280": "Trascina e rilascia i documenti qui",
    "BLD00543": "Numerazioni",
    "BLD00641": "Numero",
    "RBC2042": "Stato",
    "BLD00970": "Rete di Origine",
    "BLD00971": "Stato di Portabilità",
    "BLD00972": "Rete di Portabilità",
    "BLD00973": "Rete di Roaming",
    "BLD01503": "Richiesto il",
    "BLD01524": "I Verified SMS aggiungono la verifica del mittente e il marchio agli SMS aziendali, rendendoli più sicuri e affidabili.",
    "BLD00371": "Visualizza",
    "BLD00286": "Aggiungi Tag",
    "BLD00385": "Tag",
    "BLD00297": "Num. di Contatti",
    "BLD00969": "Nome Tag",
    "BLD00287": "Nome del Tag (obbligatorio)",
    "BLD00290": "Descrizione (facoltativa)",
    "RBC2077": "Trascina e rilascia i documenti qui",
    "RBC2078": "o",
    "RBC2079": "Clicca qui per caricarli",
    "BLD00336": "Scarica un esempio di file CSV",
    "BLD00330": "Importa Contatti",
    "BLD00344": "Non include il Prefisso Internazionale?",
    "BLD00345": "Prefisso internazionale",
    "BLD00372": "Verifica Numero",
    "BLD00373": "Visualizza Contatto",
    "BLD00374": "Nome e Cognome",
    "BLD00375": "Città",
    "BLD00376": "Stato",
    "BLD00377": "Nazione",
    "BLD01528": "Informazioni per i Verified SMS",
    "BLD00447": "Dettagli Numero",
    "BLD00454": "Dettagli Aggiuntivi",
    "BLD00457": "Indirizzo (Max. 256 caratteri)",
    "BLD00459": "Categoria del Business (Tipologia di servizio)",
    "BLD00460": "Contatto Email",
    "BLD00461": "Sito web",
    "BLD01038": "Informazioni del Brand",
    "BLD01516": "Nome del Brand",
    "BLD01509": "Nome del Contatto",
    "BLD01029": "Display name dell'Agent",
    "BLD01030": "Questo è il nome dell'Agent, che sarà visibile agli utenti durante la conversazione. La lunghezza massima del nome è di 40 caratteri",
    "BLD01517": "Nome Agente",
    "BLD00381": "Operatore di Provenienza",
    "BLD00382": "Operatore di Portabilità",
    "BLD00383": "Operatore di Roaming",
    "BLD00004": "Indirizzo email",
    "BLD00505": "Verifica Numero Stato",
    "BLD00332": "Copia & Incolla i Numeri",
    "dateFilterToday": "Oggi",
    "dateFilterWeek": "Questa settimana",
    "dateFilterMonth": "Questo mese",
    "dateFilterLastThreeMonth": "Ultimi 3 mesi",
    "dateFilterLastYear": "Ultimo anno",
    "mainTotal": "Totale",
    "mainCreditSpent": "Credito utilizzato",
    "timePeriod": "Finestra temporale",
    "typeOfReport": "Tipologia di Report",
    "tabular": "Ultimi 7 giorni",
    "summary": "Range personalizzato",
    "selectCountry": "Seleziona una nazione",
    "overviewWidgetWhatsappPlan": "Iscriviti a WhatsApp",
    "BLD00660": "Sound Manager",
    "unsubscribeNum": "Annulla l'iscrizione",
    "BLD00544": "Aggiungi file audio",
    "BLD00566": "Visualizza file audio",
    "BLD00565": "Modifica file audio",
    "BLD00564": "Scade tra",
    "BLD00547": "Seleziona tipologia audio",
    "BLD00552": "Seleziona i tag",
    "BLD00941": "Prezzo",
    "BLD00480": "Visualizza Numeri",
    "BLD02310": "Seleziona le Funzionalità",
    "BLD02237": "Numero Verde",
    "BLD00940": "Funzionalità",
    "BLD00525": "Paga",
    "BLD00793": "Azienda",
    "searchBillByInvoiceNo": "Cerca per numero fattura",
    "BLD00427": "Aggiungi Variabile",
    "BLD1565": "Dati Recenti",
    "BLD00271": "Approvato",
    "BLD00272": "In attesa",
    "BLD00273": "Rifiutato",
    "BLD02265": "Tutto",
    "BLD00958": "Costo",
    "BLD00963": "Formato",
    "BLD00530": "Da",
    "BLD01300": "Da",
    "BLD01301": "A",
    "BLD00151": "a",
    "BLD00428": "Corpo del Template",
    "BLD00483": "Prova la Sandbox",
    "BLD00537": "Acquista un piano",
    "BLD00536": "Benvenuto su Whatsapp!",
    "BLD00634": "Raggiungi i tuoi clienti oggi stesso con l'account WhatsApp for Business",
    "RBC1433": "* Ti potrebbe essere addebitato un importo minimo per questa transazione",
    "BLD00531": "A Numero di cellulare",
    "BLD00533": "Parametri",
    "whatsappUserId": "Inserisci un titolo per procedere",
    "messageType": "Data di Creazione",
    "messageContent": "Scaduto",
    "needed": "Nessun Risultato Trovato",
    "notNeeded": "file slicing",
    "VSMS": "VSM",
    "selectCallStatus": "Chiamata Da",
    "ivrName": "Messaggi",
    "callSource": "Nome Agente",
    "callID": "ID Chiamata",
    "callType": "Tipologia",
    "deliveryStatusWidgetSeeMoreStatusCode": "Codice stato",
    "overviewWidgetTotalMKT": "Totale messaggi MKT",
    "overviewWidgetTotalTXN": "Totale messaggi TXN",
    "overviewWidgetTotalOTP": "Totale messaggi OTP",
    "overviewWidgetTotalSMSDelivered": "Totale SMS consegnati",
    "overviewWidgetTotalSMSFailed": "Totale SMS non consegnati",
    "deliveryStatusWidgetSent": "Inviati",
    "deliveryStatusWidgetRead": "Leggi",
    "fileName": "Nome del file",
    "BLD00560": "Cerca per file audio",
    "deleteConf": "Sei sicuro di voler eliminare il file?",
    "min3Char": "Il nome deve contenere almeno 3 caratteri",
    "creditWidgetPrepaidWidget": "Credito prepagato utilizzato",
    "creditWidgetPostpaidWidget": "Credito postpagato utilizzato",
    "creditWidgetBalance": "Saldo",
    "creditWidgetMonthlyUsage": "Credito utilizzato questo mese",
    "creditWidgetMonthlyRecharge": "Il credito utilizzato questo mese verrà azzerato il",
    "creditWidgetChannels": "Channels",
    "creditWidgetTopupNow": "Ricarica Ora",
    "creditWidgetPayNow": "Paga ora",
    "creditWidgetSpentForSMS": "Spesi di SMS",
    "creditWidgetSpentForVoice": "Spesi di Voice",
    "creditWidgetSpentForWhatsapp": "Spesi di WhatsApp",
    "creditWidgetDue": "Totale Dovuta",
    "creditWidgetLastRecharge": "Ultima ricarica il",
    "For": "di",
    "creditLookUp": "Lookup",
    "creditWidgetNumbers": "Numbers",
    "creditWidgetGBM": "GBM",
    "creditWidgetTotalAmount": "Importo totale",
    "creditWidgetNextBilling": "Prossimo pagamento {{amount}} il {{date}}",
    "downloadFailed": "Spiacenti, a causa di un errore sconosciuto, il download non è riuscito.",
    "fromNumber": "Dal numero",
    "reportsSetFilterMessage": "Verifica Numero Stato",
    "reportCharSpecialText": "Relazione deve contenere caratteri alfanumerici solo.",
    "titleReq": "Campo obbligatorio",
    "callTypeSel": "Selezionare il tipo di chiamata",
    "entNum": "Inserisci numero",
    "genReport": "* Il report generato verrà inviato all'indirizzo email registrato",
    "repField": "Selezionare Campi report",
    "filterApplied": "Filtro applicato",
    "addFilter": "Aggiungi filtro",
    "setFilter": "Imposta filtro per limitare i risultati",
    "detailed": "Dettagliato",
    "typeOfRep": "Tipologia di Report",
    "toNum": "a numero",
    "fromNum": "dal numero di",
    "onlyNumAll": "Sono ammessi solo numeri.",
    "maxChar40": "Il nome deve contenere al massimo 40 caratteri.",
    "reqOn": "Richiesto il",
    "sel2Country": "Selezionare a paese",
    "selfromCountry": "Scegliere da paese",
    "deliveryReportsmsDownload": "Il Report sulla consegna degli SMS è stato scaricato correttamente.",
    "deliveryReportwhatsappDownload": "Il Report sulla consegna dei messaggi WhatsApp è stato scaricato correttamente.",
    "performanceDeliveryReportDownload": "Il Report sui tempi di transito degli SMS è stato scaricato correttamente.",
    "overviewsmsReportDownload": "Il Report SMS è stato scaricato correttamente.",
    "overviewwhatsappReportDownload": "Il Report su WhatsApp è stato scaricato correttamente.",
    "assetsSenderIdReportDownload": "Il Report sui Sender ID è stato scaricato correttamente.",
    "assetsSmsTemplateReportDownload": "Il Report sui Template è stato scaricato correttamente.",
    "assetsDidNumbersReportDownload": "Il Report sulle Numerazioni è stato scaricato correttamente.",
    "assetsWaNumbersReportDownload": "Il Report sulle numerazioni per WhatsApp è stato scaricato correttamente.",
    "assetsWhatsappTemplateReportDownload": "Il Report sui Template WhatsApp è stato scaricato correttamente.",
    "assetsKycDocsReportDownload": "Il Report sulla documentazione è stato scaricato correttamente.",
    "creditReportDownload": "Il Report sull'utilizzo del credito è stato scaricato correttamente.",
    "reportExtractedSuccess": "Report extracted successfully.",
    "startTime": "Ora di inizio",
    "newFileMsg": "Non hai ancora aggiunto alcun file audio",
    "soundSubMsg": "Aggiungi un file audio cliccando su 'aggiungi file audio'",
    "addNewSound": "Aggiungi File Audio",
    "nothingToReport": "Nessun report per ora",
    "nothingToReportDescription": "Una volta che avrai configurato i canali e iniziato ad usarli, potrai vedere qui le performance.",
    "nothingToReportButton": "Configura i Canali",
    "submit": "Invia",
    "BLD02232": "In entrata",
    "BLD02234": "In uscita",
    "BLD02300": "Seleziona la Categoria",
    "BLD02210": "Seleziona Stato",
    "searchReportTitle": "Cerca per nome del report",
    "fromCountry": "Paese di Origine",
    "toCountry": "Paese di Destinazione",
    "callStartTime": "Orario di inizio",
    "unabletoDownload": "Impossibile scaricare il file",
    "numberType": "Tipologia Numero",
    "numberPattern": "Numero del modello",
    "uploadDocumentStatement": "Si prega di caricare documenti validi per la verifica",
    "monthlyCharges": "Costo mensile",
    "searchResults": "risultati della ricerca",
    "provideValidInputsNumbersAndLetters": "Si prega di inserire caratteri validi - È possibile utilizzare numeri e lettere.",
    "sameSoundNameErrorMsg": "Un file audio con lo stesso nome esiste già",
    "requestFirstReport": "Richiedi il tuo primo report",
    "gainInsightsToData": "Acquisire conoscenze ai vostri dati tramite rapporti",
    "subExpireRenewMsg": " Il tuo noleggio di questa numerazione è scaduto. Per riattivarlo, clicca sul pulsante Rinnova.",
    "docRejectPart1": "Oops! I documenti approvati ricevuti respinti a causa di",
    "resubmitandApprove": "Si prega di inviare nuovamente e farli approvato",
    "docUnderReview": "I vostri documenti caricati sono in fase di revisione. Numero sarà disponibile una volta che i documenti sono stati approvati.",
    "activeTill": "attivo fino",
    "month": "Mese",
    "uploadedDoc": "documenti caricati",
    "welcomeToNum": "Benvenuto in Numbers",
    "completeKYCtoStart": "Completa il tuo KYC e ricaricare il vostro account per iniziare i numeri di acquisto",
    "topUpToBuyNum": "Top per comprare un numero",
    "cancelNumSubscription": "Sei sicuro di voler annullare la sottoscrizione",
    "resubmit": "Invia di nuovo",
    "docUploaded": "Documento (s) caricato",
    "nextBillingOn": "Successivo fatturazione",
    "nextBilling": "Successivo fatturazione",
    "selFromUploadDoc": "Seleziona da caricati Documenti",
    "uploadForVerification": "Si prega di caricare documenti validi per la verifica",
    "continue": "Continua",
    "deactivatingIn": "Disattivazione in",
    "numbUnsubscribed": "numero Unsubscribed",
    "docRejected": "Documento (s) ha respinto",
    "subsNum": "Sottoscrivi il numero",
    "reSubNum": "Sottoscrivi",
    "noNumToDisplay": "Non ci sono numeri da mostrare",
    "noNumSubsribed": "Nessun numero sottoscritte",
    "selDoc": "selezionare Documenti",
    "invalidFileExt": "Si prega di selezionare un tipo di file valido. ad esempio: .pdf, .jpg",
    "selAreaStateCountry": "Seleziona una Regione o una Nazione",
    "startTyping": "Iniziare a digitare...",
    "searchNum": "Cerca un numero",
    "continueBenefitAfterPayment": "Potrai continuare a beneficiare di questo business plan una volta completato il pagamento.",
    "numberChargeText": "Sarete ora verrà addebitato l'importo di {{currency}} {{price}} su base mensile ricorrente ad ogni data di fatturazione.",
    "renew": "Rinnovare",
    "expiredOn": "scaduto il",
    "renewNum": "Rinnova Numero",
    "resubmitDocs": "Documenti reinvio",
    "notSufficientFund": "Non si dispone di fondi sufficienti per completare la transazione.",
    "renewPostpaidExpiry": "Scusate! Il tuo rinnovo dell'abbonamento non può essere elaborato come lei ha raggiunto il limite massimo di credito di questo mese. Si prega di entrare in contatto con la nostra",
    "supportTeam": "team di supporto",
    "furtherAssistance": "Per ulteriore assistenza su questo.",
    "totalPayable": "totale da pagare",
    "numbersNote" : "Le risorse numeriche sono un prerequisito per usufruire dei servizi di Voce e di determinati servizi SMS. I costi indicati si riferiscono all'utilizzo del servizio con le risorse numeriche come input per i servizi sottoscritti.",
    "setupCostOneTime": "Setup Costo (One-Time)",
    "uploadFail": "Caricamento fallito",
    "subscriptionFailed": "richiesta di sottoscrizione non riuscita",
    "successfullySubscribed": "sottoscritto con successo",
    "requestExecuted": "Richiedi successo eseguito!",
    "editAPIKey": "Modifica API Key",
    "createAPIKey": "Crea una API Key",
    "whiteListedIP": "Indirizzi IP in whitelist ",
    "whitelistedTltip": "Le chiamate alle API di Kaleyra potranno essere effettuate solo dagli indirizzi IP inseriti in whitelist. Per aggiungere più indirizzi IP, separali con una virgola.",
    "neverUsed": "Mai utilizzata",
    "lastUsed": "Ultimo utilizzo",
    "apiKeyAlert": "Assicurati di scaricare e conservare l'API key in modo sicuro. E' possibile effettuare il download una volta sola.",
    "apiDetails": "Dettagli delle API",
    "apiDomain": "Dominio API",
    "apiSid": "SID (ID di sicurezza)",
    "apiKey": "API Key",
    "readDocument": "Leggi la documentazione",
    "apiUpdateSuccess": "API key aggiornata con successo",
    "apiDeleteSuccess": "API key eliminata con successo",
    "apiValidIp": "Inserisci indirizzi IP validi per procedere",
    "createAPIKeySuccess": "API Key generata con successo",
    "IPplaceholder": "Eg. 192.168.1.1",
    "item": "Risultato",
    "items": "Risultati",
    "APIAskForDelete": "Sei sicuro di voler eliminare questa API Key",
    "subscribeNumber": "Numero di iscrizione",
    "playRecording": "Riproduci registrazione",
    "reportType": "Tipologia di Report",
    "callDetails": "Dettagli chiamata",
    "recordingDetails": "Dettagli di registrazione",
    "agentBridgeSameCountry": "I numeri di Agent, Cliente e Bridge devono essere della stessa Nazione",
    "newConversation": "nuova conversazione",
    "startCall": "Avvia una chiamata",
    "spcCharNotAllowed": "Si prega di inserire caratteri validi - È possibile utilizzare esclusivamente numeri, lettere, trattini e underscore.",
    "start": "Inizia",
    "schedule": "Pianifica",
    "whomToDialFirst": "Chi chiamare per primo",
    "noOfRetry": "Nr. tentativi successivi",
    "selCallerId": "Selezionare ID chiamante",
    "customerNum": "Numero del cliente",
    "agentNum": "Numero dell'Agent",
    "scheduleCall": "Pianifica una chiamata",
    "scheduleCallMsg": "Pianifica il click-to-call in un tempo tra i prossimi15 minuti e i prossimi 3 giorni.",
    "validCountryMsg": "Inserisci un numero valido, compreso il presfisso internazionale.",
    "differentCustomerAgentNumMsg": "Il campo Agent e Cliente devono avere numeri diversi.",
    "conCreatedmsg": "Click to Call creata con successo.",
    "scheduleTimeLaterError": "L'orario deve essere maggiore di 15 minuti da ora",
    "myProfile": "Profilo",
    "profileSettings": "Impostazioni Profilo",
    "companyName": "Nome dell'azienda",
    "timeZone": "Fuso Orario",
    "phone": "Numero di Telefono",
    "inr": "INR",
    "mainSaveChanges": "Salva Modifiche",
    "photoChange": "Cambia immagine",
    "currency": "Valuta",
    "selectTimeZone": "Fuso Orario",
    "fullNameReq": "Il nome completo è obbligatorio  Inserisci tuo nome completo per procedere.",
    "fullNameInvalid": "Il nome non è valido  Inserisci un nome completo valido per procedere.",
    "fullNameMin3": "Il nome completo deve contenere un minimo di 3 caratteri  La lunghezza minima del nome completo è di 3 caratteri.",
    "fullNameMax40": "Il nome completo può contenere un massimo di 40 caratteri  Il nome completo non può contenere più di 40 caratteri",
    "companyNameReq": "Inserisci il nome dell'azienda",
    "companyNameMax": "Il nome dell'azienda può contenere un massimo di 250 caratteri  Il nome dell'azienda non può contenere più di 50 caratteri.",
    "reqExec": "Modifiche salvate",
    "noAPIKeys": "Nessuna API Key creata",
    "tableNoResults": "Nessun risultato!",
    "tableNoResultsDesc": "La tua ricerca non ha prodotto alcun risultato",
    "downloadExpired": "Non è più possibile scaricare il file",
    "emptyBillHistory": "Storico Fatture",
    "emptyBillHistoryDesc": "Nessun dato disponibile",
    "done": "Fine",
    "topup": "Ricarica",
    "preferences": "Preferenze",
    "autoDebit": "Ricarica Automatica",
    "click2call": "Click to Call",
    "callbackProfileDeleteConf": "Sei sicuro di voler eliminare il profilo di callback?",
    "callbackProfileEnableConf":"Assicurarsi di abilitare questo profilo e di poterlo disabilitare in un secondo momento.",
    "callbackProfileDisableConf":"Assicurarsi di disabilitare questo profilo e di poterlo abilitare in un secondo momento.",
    "callbackProfile": "Profili di Callback",
    "noCallbackProfile": "Non ci sono profili callback disponibili",
    "addNew": "Aggiungi nuovo",
    "httpMethod": "Metodo HTTP",
    "searchByTitle": "Ricerca per Titolo",
    "searchByProfileIdOrTitle": "Ricerca per Titolo o ID Profilo",
    "addCallbackProfile": "Aggiungi un profilo Callback",
    "selMethod": "Selezionare il metodo",
    "enterEndpoint": "Inserisci endpoint",
    "headerOptional": "Headers (facoltativo)",
    "customHeaderOptional" :"Headers (facoltativo)",
    "selAuthMethod": "Seleziona il metodo di autenticazione",
    "enterhttpMethod": "Seleziona metodo HTTP",
    "clientId" : "Client Id",
    "clientSecret" : "Client Secret",
    "authUrl" : "URL di autenticazione",
    "enableAuthentication" : "Autenticazione avanzata",
    "AutheticateData": "Autenticare i dati di callback tramite l'autenticazione avanzata.",
    "key": "Chiave",
    "value": "Valore",
    "addMore": "Aggiungi altro",
    "bodyType": "Body Type",
    "reqBody": "Request Body",
    "callbackSuccess": "Profilo di Callback creato con successo",
    "callbackDelete": "Profilo di Callback eliminato con successo",
    "callbackEnable":"Il profilo è stato abilitato con successo",
    "callbackDisable":"Il profilo è stato disabilitato con successo",
    "callbackTestValidationMissingFieldsError": "Campi obbligatori non validi: URL e metodo HTTP",
    "callbackTestValidationURLNotValid": "URL non valido",
    "callbackEnableTestCallbackSuccess": "Test callback con successo",
    "callbackEnableTestCallbackFailure": "Test callback fallito. Si prega di aggiornare il profilo e riprovare nuovamente.",
    "createdBetween": "Creato il",
    "clearAllFilters": "Rimuovi tutti i filtri",
    "editCallbackProfile": "Modifica Profilo di Callback",
    "callbackUpdate": "Profilo di Callback aggiornato con successo",
    "invalidJsonMsg": "Si prega di fornire un JSON valido",
    "invalidXmlMsg": "Si prega di fornire un XML valido",
    "validInput": "Inserisci un input valido",
    "startDate": "Data di Inizio",
    "endDate": "Data di fine",
    "order": "Ordine",
    "paymentReceipt": "Ricevuta di Pagamento",
    "invoice": "Fattura",
    "paid": "Pagato",
    "unpaid": " Non pagato",
    "awaitingConfirmation": "In Attesa di conferma",
    "card": "CARTA DI CREDITO",
    "team": "Team",
    "notification": "Notifiche",
    "deliveryStatusWidgetDelivered": "Consegnato",
    "overviewWidgetSMSDelivered": "Consegnato",
    "overviewWidgetWappDelivered": "Consegnato",
    "overviewWidgetWhatsAppDelivered": "Consegnato",
    "overviewWidgetWhatsAppFailed": "Fallito",
    "noData": "Dati non disponibili!",
    "noDataText": "Nessun dato disponibile per il periodo selezionato.",
    "overviewWidgetManageChannel": "Gestisci Canali",
    "overviewWidgetTotalSMSSent": "Totale SMS inviati",
    "dashboardSeeMore": "Mostra dettagli",
    "overviewWidgetWhatsAppNumber": "Numero WhatsApp",
    "overviewWidgetWhatsAppSent": "Totale Inviati",
    "overviewWidgetWhatsAppTemplate": "Messaggi Template",
    "overviewWidgetWhatsAppSession": "Messaggi di Sessione",
    "overviewWidgetWhatsAppIncomingMessage": "Messaggi in Entrata",
    "deliveryStatusWidget": "Stato di Delivery",
    "status": "Stato",
    "creditSeeMore": "Credito Utilizzato",
    "creditStatusWidgetHeader": "Credito Utilizzato",
    "channelTypevoice": "Voce",
    "type": "Tipologia",
    "overviewWidgetVoiceCompleted": "Completata",
    "tableHeaderFromDate": "Da",
    "tableHeaderToDate": "A",
    "statusPlaceholder": "Seleziona Stato",
    "download": "Scarica",
    "allCountries": "Tutte le Nazioni",
    "overviewWidget": "Overview",
    "tabSenderId": "Sender ID",
    "overviewWidgetSMSSenderId": "Sender ID",
    "payAsYouGoBold": "Stai utilizzando il piano a consumo Pay-as-you-go.",
    "BLD00458": "Descrizione del Business (Max. 256 caratteri)",
    "endpointValid": "Il campo può avere una lunghezza massima di 2048 caratteri",
    "deliveryStatusWidgetTablePercentage": "Percentuale",
    "deliveryStatusWidgetTableStatus": "Descrizione Stato",
    "lookup": "lookup",
    "dashboardAddWidgets": "Aggiungi Widget",
    "BLD01505": "Apply for Verified SMS",
    "rbmColorinfosub": " sul rapporto di contrasto",
    "mainExport": "Esporta",
    "imageHeightandWidth": "L'immagine deve essere in ",
    "payAsYouGoModel": "Modello Pay-as-you-go",
    "deliveryStatusWidgetTableTotal": "Totale",
    "manage": "Gestisci",
    "channelTypesms": "SMS",
    "channelTypewhatsapp": "WhatsApp",
    "overviewWidgetError": "Errore",
    "overviewWidgetSMStxn": "TXN",
    "overviewWidgetSMSmkt": "MKT",
    "overviewWidgetSMSOtp": "OTP",
    "overviewWidgetVoiceDID": "Numerazioni DID",
    "overviewWidgetWappIncoming": "In entrata",
    "overviewWidgetWappSession": "Sessione",
    "overviewWidgetWappTemplate": "Template",
    "overviewWidgetWappPlan": "Piano",
    "overviewWidgetWappFailure": "Non riuscito",
    "assetsWidgetSenderId": "Sender ID",
    "assetsWidgetDidNumbers": "Numerazioni DID",
    "reload": "Ricarica",
    "somethingWentWrong": "Si è verificato un errore",
    "reloadText": "Clicca su ricarica per vedere i dati per il periodo selezionato.",
    "createAccount": "Crea il tuo account",
    "contacts": "Contatti",
    "tags": "Tag",
    "addContact": "Aggiungi contatto",
    "blacklisted": "In blacklist",
    "namePlaceholder": "Inserisci nome",
    "emailPlaceholder": "Inserisci email",
    "tagsPlaceholder": "Seleziona tag",
    "name": "Nome",
    "createdFrom": "Creato dal",
    "createdTill": "Creato fino al",
    "yes": "Sì",
    "no": "No",
    "activationAccountName": "Nome account",
    "activationBusinessManagerId": "Business Manager ID",
    "activationDisplayName": "Nome visualizzato",
    "activationIncomingUrl": "Incoming URL",
    "smsApplySenderID": "Richiedi Sender ID",
    "smsEditSenderID": "Modifica Sender ID",
    "smsSenderIdDetails": "Dettagli Sender ID",
    "tableHeaderFrom": "Da",
    "tableHeaderTo": "A",
    "messageId": "ID messaggio",
    "messageIdPlaceholder": "Inserisci ID messaggio",
    "source": "Origine",
    "sourcePlaceholder": "Seleziona origine",
    "sentDatePlaceholder": "Seleziona data di invio",
    "deliveryDatePlaceholder": "Seleziona data di consegna",
    "typePlaceholder": "Seleziona tipologia",
    "formatPlaceholder": "Seleziona un formato",
    "format": "Formato",
    "BLD1941": "Nome visualizzato",
    "BLD1181": "Aggiungi numero",
    "RBC1444": "Seleziona stato",
    "BLD01502": "SMS verificato",
    "BLD1726": "Sito web",
    "BLD00005": "Email",
    "BLD00607": "Descrizione",
    "BLD01514": "Sender ID",
    "BLD1139": "Descrizione",
    "BLD00452": "Incoming URL",
    "templateHeader": "Header (facoltativo)",
    "body": "Corpo del testo",
    "templateFooter": "Footer (facoltativo)",
    "templateButton": "Pulsante (facoltativo)",
    "templateDetails": "Dettagli del template",
    "headerType": "Tipologia header",
    "headerText": "Testo header",
    "footer": "Footer",
    "buttonType": "Tipologia di pulsante",
    "mainCategory": "Categoria",
    "tabLogs": "Dati recenti",
    "recentlyUploadedDoc": "Documenti caricati di recente",
    "BLD00159": "Rete",
    "BLD00331": "File",
    "basicInformation": "Informazioni base",
    "mainFullNamePlaceholder": "Nome e cognome (facoltativo)",
    "mainEmailAddressPlaceholder": "Indirizzo email (facoltativo)",
    "mainFullName": "Nome e cognome {{text}}",
    "mainCityPlaceHolder": "Città (facoltativo)",
    "mainCity": "Città",
    "mainStatePlaceholder": "Stato (facoltativo)",
    "mainState": "Stato",
    "selectTagsPlaceholder": "Seleziona i tag (facoltativo)",
    "selectTags": "Seleziona tag",
    "customFields": "Campi personalizzati",
    "viewAllFields": "Visualizza tutti i campi",
    "customField": "Campo personalizzato {{index}}",
    "addNewField": "Aggiungi nuovo campo",
    "smsAddTemplate": "Aggiungi template",
    "smsTemplateTitle": "Titolo",
    "smsTemplatePurpose": "Scopo",
    "smsTemplateCreatedOn": "Creato il",
    "contentPlaceholder": "Contenuto",
    "purposePlaceholder": "Scopo",
    "smsTemplateDetails": "Dettagli del template",
    "blacklist": "Bloccare\/ mettere in blacklist l'utente?",
    "performanceWidgetTTlDelivered": "Totale Consegnati",
    "fileEditMsg": "File modificato correttamente",
    "BLD00602": "Formato del file non valido. Il file deve essere in formato mp3, wav",
    "downloadNoDataError": "Non ci sono dati per il periodo selezionato.",
    "searchDocuments": "Cerca documenti",
    "notRecharged": "Non ancora ricaricato.",
    "performanceWidgetTTlDeliveredPercentage": "Percentuale media di consegnato",
    "unlimited": "Illimitato",
    "customPricing": "Prezzo personalizzato",
    "whatsAppFeeMsg": "Gratuito verso l'India \/ WhatsApp Fee verso il resto del mondo",
    "klr0001": "Inserisci o copia i numeri di telefono qui. Es. +119966778899 639090909090",
    "klr0002": "Nessun contatto selezionato",
    "klr0003": "Seleziona Data",
    "klr0004": "Scegli Orario",
    "klr0005": "Invia",
    "klr0006": "Esporta",
    "createdDate": "Creato",
    "addSA": "Aggiungere Sticky agente",
    "SAText": "Agents Sticky",
    "SAEmptyStateHead": "Iniziare ad aggiungere agenti appiccicose",
    "SAEmptyStateDesc": "Collegare i clienti preziosi agli agenti dedicati su ogni chiamata in avanti con l'agente appiccicoso.",
    "disableSA": "Disabilita Sticky agente",
    "SAHelpTxt": "Aggiungere più numeri con separati da virgola",
    "editSA": "Modifica Sticky agente",
    "SACreate": "agente Sticky \"{{title}}\" creato con successo",
    "SAUpdate": "agente Sticky \"{{title}}\" cancellato con successo",
    "SADelete": "agente Sticky \"{{title}}\" aggiornato con successo",
    "enableSA": "Abilita Sticky agente",
    "tabURLShortener": "URL Shortener",
    "mainCreatedOn": "Created on",
    "RBC161": "Richiedi Sender ID",
    "KLR00103": "Content",
    "BLD00481": "Edit Number",
    "KLR0007": "Starts with",
    "KLR0008": "Ends with",
    "KLR0009": "Contains",
    "KLR0010": "Any",
    "KLR0011": "Toll Free",
    "KLR0012": "Mobile",
    "KLR0013": "Fixed Line",
    "KLR0014": "Setup Cost (one time)",
    "KLR0015": "Buy Now",
    "KLR0016": "Account Update",
    "KLR0017": "Native Plugins",
    "KLR0032": "Nome del Sender ID",
    "KLR0018": "Add Sticky Agent",
    "KLR0019": "Sticky Agents",
    "KLR0020": "Start adding sticky agents",
    "KLR0021": "Connect your valuable customers to dedicated agents on every call forward using the sticky agent.",
    "KLR0022": "Disable Sticky Agent",
    "KLR0023": "Add up to 10 numbers separated with comma",
    "KLR0024": "Edit Sticky Agent",
    "KLR0025": "Sticky agent \"{{title}}\" created successfully",
    "KLR0026": "Sticky agent \"{{title}}\" updated successfully",
    "KLR0027": "Sticky agent \"{{title}}\" deleted successfully",
    "KLR0028": "Enable Sticky Agent",
    "KLR0029": "Are you sure you want to delete the Sticky Agent",
    "KLR0030": "Active",
    "KLR0031": "Inactive",
    "KLR0034": "I report sono protetti da password. La password sarà condivisa separatamente tramite l'e-mail registrata.",
    "KLR0035": "Range di Date",
    "KLR0036": "Select fields to be exported to the report",
    "KLR0037": "Select None",
    "KLR0038": "Add Report Filters",
    "KLR0039": "Request Report Filters",
    "KLR0040": "Generate",
    "loggedInTime": "Periodo",
    "views": "Views",
    "BLD00749": "Unique clicks",
    "lastViewed": "Last viewed",
    "downloadReport": "Download report",
    "originalURL": "URL Originale",
    "shortURL": "URL Abbreviato",
    "created": "Data di Creazione",
    "noUrlMessage": "Nessun URL disponibile",
    "BLD00613": "Sender ID",
    "F104": "Il formato del file non è valido",
    "KLR00100": "Dettagli",
    "KLR00101": "Timeline",
    "KLR00102": "Nome del Sender ID",
    "KLR00104": "Inserisci qui il messaggio",
    "KLR00105": "Inserisci l'URL da accorciare",
    "KLR00106": "Link",
    "KLR00107": "Aggiungi Template",
    "KLR00108": "Modifica Template",
    "KLR00109": "Contenuto del Template",
    "KLR00110": "Template timeline",
    "KLR00111": "Dettagli del Template",
    "KLR00112": "Accesso effettuato tra le",
    "KLR00113": "to",
    "KLR00114": "Create your first Template",
    "KLR00115": "Create your first sender ID",
    "KLR00116": "Launch campaign at ligntening speed",
    "KLR00117": "Carica documenti",
    "KLR00118": "Caricati recentemente",
    "KLR00150": "Sent between",
    "KLR00151": "Delivered between",
    "entrPrisePlan": "Enterprise Plan",
    "outboundCustomPlanInd": "per Outbound Session message sent to India",
    "outboundCustomPlanOth": "per Outbound Session message sent to rest of the World",
    "KLR00119": "Cerca per Sender ID",
    "KLR00120": "Cerca per nome del template",
    "KLR00140": "Creato il",
    "KLR00500": "Area",
    "KLR00501": "Note",
    "KLR00121": "In fase di verifica",
    "KLR0041": "Use Enter to add multiple numbers",
    "KLR0042": "Use Enter to add multiple Call IDs",
    "KLR0043": "Export Log",
    "KLR0044": "Use Enter to add multiple Speech IDs",
    "KLR00141": "Trascina e rilascia i documenti qui o Clicca qui per caricarli",
    "KLR00142": "In fase di verifica",
    "KLR00143": "Number",
    "KLR00144": "Add",
    "KLR00145": "WebEngage helps you craft contextual and personalised campaigns to engage your users. WebEngage now supports WhatsApp as an engagement channel through Kaleyra.",
    "KLR00146": "Eloqua is a SaaS platform for marketing automation offered by Oracle that helps B2B marketers and organisations manage marketing campaigns and sales lead generation. Kaleyra support Send SMS actions through the campaign and program canvas.",
    "KLR00147": "LeadSquared is a complete Marketing Automation and CRM software for businesses. Increase sales efficiency further to communicate with leads using Kaleyra’s messaging support on SMS and WhatsApp.",
    "KLR00148": "Opencart is a PHP based open-source platform that deals with online store management. Notify customers and admins to keep track of new orders, new customer registrations, update in order status, and more. ",
    "KLR00149": "Salesforce provides customer relationship management service and also sells a complementary suite of enterprise applications. Send SMS messages to Contacts, Accounts, Leads and Opportunities seamlessly. ",
    "KLR00250": "Ti diamo il benvenuto nel chatbot",
    "KLR00251": "Nessun chatbot da mostrare",
    "KLR00252": "Crea nuovo bot",
    "KLR00253": "Versione",
    "KLR00254": "Contenuto",
    "KLR00255": "Ultimo aggiornamento",
    "KLR00256": "Rinomina chatbot",
    "KLR00257": "Aggiungi domanda",
    "KLR00258": "Pubblica chatbot",
    "KLR00259": "Crea nuovo chatbot",
    "KLR00260": "Nome chatbot",
    "KLR00261": "Domande",
    "KLR00262": "Filtra per tag",
    "KLR00263": "Aggiungi nuova domanda",
    "KLR00264": "Domanda",
    "KLR00265": "Contenuto",
    "KLR00266": "Nessuna domanda aggiunta",
    "KLR00267": "Nessuna domanda del chatbot da mostrare",
    "KLR00268": "Configurazione chatbot",
    "KLR00269": "Seleziona numero WhatsApp",
    "KLR00270": "Seleziona chiave API",
    "KLR00271": "Al fine di pubblicare questo chatbot, devi avere un numero WhatsApp e una chiave API di sviluppatore",
    "KLR00272": "Abbonati a numero WhatsApp",
    "KLR00273": "Genera chiave API",
    "KLR00274": "Risposte",
    "KLR00275": "Tag",
    "KLR00276": "Aggiungi domanda",
    "KLR00277": "Aggiungi risposta",
    "KLR00278": "Aggiungi tag",
    "KLR00279": "Risposta",
    "KLR00280": "Seleziona tutto",
    "KLR00281": "Vuoi davvero annullare la pubblicazione di questo chatbot?",
    "KLR00282": "Non annullare la pubblicazione",
    "KLR00283": "Annulla la pubblicazione del chatbot",
    "KLR00284": "Al fine di pubblicare questo chatbot, devi avere una chiave API di sviluppatore",
    "KLR00285": "Al fine di pubblicare questo chatbot, devi avere un numero WhatsApp",
    "KLR00286": "Elimina chatbot",
    "KLR00287": "Vuoi davvero eliminare questo chatbot?",
    "KLR00288": "Attenzione! L'aggiornamento del numero WhatsApp comporterà l'interruzione del chatbot associato al numero precedente. Continuare?",
    "KLR00289": "Non modificare",
    "KLR00290": "Sì, modifica numero",
    "KLR00291": "Chatbot creato correttamente",
    "KLR00292": "Chatbot rinominato correttamente",
    "KLR00293": "Chatbot eliminato correttamente",
    "KLR00294": "Sposta in bozze",
    "KLR00295": "Domanda",
    "KLR00296": "Domande",
    "KLR00297": "Domanda aggiornata correttamente",
    "KLR00298": "Il nome del chatbot non esiste",
    "KLR00299": "Utilizza Invio per aggiungere tag multipli",
    "KLR00300": "Domanda aggiornata correttamente",
    "KLR00301": "Ops! Impossibile trovare un chatbot.",
    "KLR00302": "Inizia a creare nuovi flussi utilizzando il nostro generatore di chatbot e scopri la potenza dell'IA",
    "KLR00303": "Vuoi davvero eliminare questa domanda?",
    "KLR00304": "WhatsApp",
    "KLR00305": "Attiva numero WhatsApp",
    "KLR00306": "Serve almeno una domanda per pubblicare il chatbot",
    "KLR00307": "Chatbot pubblicato correttamente su WhatsApp.",
    "KLR00308": "Chatbot spostato in bozze.",
    "KLR00309": "Panoramica chatbot",
    "KLR00310": "Sessioni totali",
    "KLR00311": "Messaggi totali",
    "KLR00312": "Tempo sessione medio",
    "KLR00313": "Clienti univoci",
    "KLR00314": "Minuti",
    "KLR00315": "Min.",
    "KLR00316": "Tutto il tempo",
    "KLR00317": "Lancia una campagna vocale!",
    "KLR00400": "Documents rejected due to",
    "KLR00401": "Unsubscribed on",
    "KLR00402": "Document(s) are under verification",
    "KLR00403": "Subscription failed due to insufficient balance",
    "KLR00404": "Start Adding Callback Profiles",
    "KLR00405": "Crea nuovo",
    "BLD01511": "Web",
    "BLD01512": "Api",
    "BLD01513": "Campagna",
    "BLD01561": "Plugin",
    "BLD01515": "Inviato",
    "BLD01562": "Non Inviato",
    "BLD01518": "Non consegnato",
    "BLD01519": "OTP",
    "BLD01520": "Marketing",
    "BLD01521": "Transactional",
    "BLD01522": "Transactional DND",
    "BLD01523": "M2M",
    "KLR00406": "Flow Execution ID",
    "emptyBillUsage": "Billing Usage",
    "emptyBillUsageDesc": "There is no data to display",
    "KLR00407": "Webhook URL",
    "KLR00408": "Webhook",
    "whatsapp_label": "Whatsapp",
    "whatsapp_key": "WA",
    "mainBillUsage": "Usage",
    "KLR00409": "Voice Call",
    "BLD01525": "Queued",
    "BLD01526": "Expired",
    "BLD01527": "Records Not Found",
    "BLD01529": "Transaction",
    "BLD01530": "Transaction DND",
    "BLD01531": "Not Allowed",
    "BLD01532": "SenderID Not Alloted",
    "BLD01533": "Invalid Template Match",
    "BLD01534": "No Credits",
    "BLD01535": "Report title is required!",
    "BLD01536": "Type of Report is required!",
    "BLD01537": "Start date is required!",
    "BLD01538": "End date is required!",
    "BLD01539": "Generated report will be sent to the registered email id",
    "BLD00135": "Alert di saldo basso",
    "BLD00136": "Riceverai un'email quando il credito del tuo account scenderà sotto la soglia specificata.",
    "BLD00137": "Soglia minima",
    "BLD00140": "Low balance alert emails",
    "BLD00141": "Inserisci più indirizzi email separati da una virgola",
    "mainEditDetails": "Modifica Dettagli",
    "BLD00482": "Si consiglia una dimensione massima del file di 5 MB e una dimensione dell'immagine di 640*640px in formato jpeg o png",
    "BLD01540": "Provide your Display name to proceed",
    "BLD01541": "Provide mobile number",
    "BLD01542": "Enter a valid landline or mobile number, VoIP numbers are not accepted",
    "BLD01571": "Add Button",
    "BLD01572": "Button",
    "BLD01573": "Template Title is mandatory",
    "BLD01574": "Retry",
    "BLD01543": "Data di Invio",
    "BLD01544": "Data di Ricezione",
    "BLD01545": "Flow Name",
    "BLD01575": "QUICK REPLY",
    "BLD01576": "PHONE NUMBER",
    "BLD01577": "None",
    "BLD01578": "Text",
    "BLD01579": "Media",
    "BLD01580": "Static",
    "BLD01581": "Dynamic",
    "BLD01582": "Button text",
    "BLD01583": "URL Type",
    "BLD01584": "Website URL",
    "BLD01585": "Quick Reply Button",
    "BLD01586": "Footer body",
    "BLD01588": "Visto",
    "BLD01589": "Modello multimediale",
    "BLD01590": "Filtri applicati",
    "BLD01591": "ID utente WhatsApp richiesto!",
    "BLD01592": "ID utente WhatsApp",
    "KLR01800": "Sì, elimina",
    "KLR01801": "Non eliminare",
    "KLR01802": "Sei sicuro di voler eliminare i Templates?",
    "KLR01803": "Conferma",
    "KLR01804": "Elimina",
    "KLR01805": "Seleziona Tutti",
    "KLR01806": "Selezionate",
    "KLR01807": "Report caricati",
    "KLR01808": "Tipologia di file",
    "KLR01809": "Nome del file",
    "KLR01810": "Totale templates\/Sender IDs",
    "KLR01811": "Stato del file",
    "KLR01812": "Accettati",
    "KLR01813": "Rifiutati",
    "KLR01814": "Caricato",
    "KLR01815": "Processing",
    "BLD01601": "Indirizza",
    "BLD01602": "ID messaggio",
    "BLD01587": "Richiesto da",
    "BLD01603": "Traccia stato",
    "BLD01604": "ID mittente",
    "BLD01605": "Tipo di report",
    "BLD01606": "Nome report",
    "BLD01600": "Il formato deve essere .csv.",
    "Delete Chatbot": "Elimina chatbot",
    "KLR00410": "Variable replaced",
    "KLR00411": "Result",
    "KLR00412": "Messaggio IVR",
    "KLR00413": "TTS",
    "KLR00414": "Audio",
    "KLR00415": "File",
    "KLR00416": "Numeri selezionati",
    "KLR00417": "Timeout",
    "KLR00418": "Profilo di richiamata",
    "KLR00419": "Var1",
    "KLR00420": "Nessuna corrispondenza",
    "KLR00421": "Data e ora",
    "KLR00422": "Widget",
    "KLR00423": "ID widget",
    "KLR00424": "Tipo di trigger",
    "KLR00425": "Flusso eseguito in data",
    "KLR00426": "Data di esecuzione",
    "KLR00427": "Benvenuto nei registri FlowBuilder",
    "KLR00430": "End Time",
    "KLR00431": "Call",
    "KLR00432": "Payload",
    "KLR00433": "Ora di inizio",
    "KLR00434": "Search Flow Execution Id",
    "KLR00435": "Nome del flusso",
    "KLR00436": "Il testo può contenere al massimo 75 caratteri",
    "titleSpcCharNotAllowed": "Sono consentiti solo lettere, numeri, spazi, trattini e underscore",
    "KLR01816": "Fallito",
    "automated_reports_sms_title": "Report SMS Automatici",
    "automated_reports_sms_desc": "Programma l'invio automatico di report SMS via email.",
    "reportFreq": "Frequenza di Invio",
    "weekly": "Settimanale",
    "daily": "Giornaliera",
    "dailyReportDesc": "Ricevi un report ogni giorno alle ore 10",
    "weeklyReportDesc": "Ricevi un report ogni Lunedì",
    "monthlyReportDesc": "Ricevi un report il 3 di ogni mese",
    "emailIds": "Indirizzi Email",
    "sendTo": "Invia a",
    "frequency": "Frequenza",
    "mailFrequency": "Frequenza Email",
    "alertForFailedCallbacks": "Alert solo per callbacks fallite",
    "BLD01622": "Nome campagna",
    "BLD01607": "Richiedi ora",
    "BLD01608": "Indirizzo del sito Web ufficiale",
    "BLD01609": "ID email aziendale",
    "BLD01610": "Descrizione del marchio",
    "BLD01611": "Seleziona ID mittenti",
    "BLD01612": "Logo",
    "BLD01613": "Questo verrà mostrato come logo del marchio nel messaggio. Dimensioni 224x224",
    "BLD01614": "Il nome del marchio è obbligatorio",
    "BLD01615": "Il sito Web è obbligatorio",
    "BLD01616": "Il nome del referente è obbligatorio",
    "BLD01617": "L'ID dell'email aziendale è obbligatorio",
    "BLD01618": "Il nome visualizzato dell'agente è obbligatorio",
    "BLD01619": "Il file è troppo grande. Dimensione massima del file: 30,00 KB",
    "BLD01621": "Specifica #NUM param. per procedere",
    "BLD01620": "No report generated as no data found in uploaded file",
    "KLR00550": "Messaggio di benvenuto, arrivederci ed errore",
    "KLR00551": "Messaggio di benvenuto",
    "KLR00552": "Messaggio di riserva",
    "KLR00553": "Messaggio di arrivederci",
    "KLR00554": "Qui apparirà una breve descrizione del messaggio di benvenuto",
    "KLR00555": "Qui apparirà una breve descrizione del messaggio di riserva",
    "KLR00556": "Qui apparirà una breve descrizione del messaggio di arrivederci",
    "KLR00557": "Aggiorna",
    "BLD01549": "Seleziona Status Trace",
    "BLD01550": "Seleziona paese",
    "BLD01551": "Tipologia di Messaggio",
    "BLD01552": "Seleziona Sender",
    "BLD01553": "Contenuto del messaggio",
    "BLD015625": "Aggiungi Filtri",
    "BLD015626": "Cerca per titolo del report",
    "Please try uploading a sound file with a minimum length of 5 secs": "Prova a caricare un file audio con una durata minima di 5 secondi",
    "BLD015627": "Cerca per Nome del Report",
    "BLD015628": "Scarica Report",
    "BLD01546": "Il nome WhatsApp che sarà visibile ai tuoi clienti. Questa impostazione viene configurata una volta sola. URL di esempio: https:\/\/example.com\/incoming_url",
    "BLD01547": "Scopri di più",
    "BLD01548": "Il formato del sito web non è valido.",
    "BLD01569": "Il formato dell'URL in ingresso non è valido.",
    "BLD01570": "Tabulare (semplice)",
    "BLD01623": "Per rispettare le linee guida dei messaggi ed evitare lo spam, ti chiediamo di creare dei modelli.",
    "BLD01624": "Utilizza i pulsanti per permettere ai tuoi cliente di rispondere o interagire.",
    "BLD01631": "Duplica",
    "BLD01632": "Inserisci il nome del nuovo flusso",
    "BLD01633": "SIP abilitato",
    "BLD01634": "Origine secondaria",
    "BLD01635": "Route abilitate vSMS",
    "BLD01636": "Seleziona route abilitate vSMS",
    "BLD01637": "Errore durante il caricamento delle route sms",
    "BLD01638": "Inserisci il Paese per procedere",
    "BLD01639": "Titolo ID mittente obbligatorio.",
    "BLD01640": "Descrizione obbligatoria.",
    "BLD01641": "L'ID entità numerico è consentito e può contenere minimo 12 cifre e massimo 30 cifre.",
    "BLD01642": "Seleziona una route abilitata vSMS",
    "chaCompleteKycDescWa": "Stai utilizzando una versione di prova. Per visualizzare il piano, inserisci i dati dell'azienda e i dati di fatturazione completando il questionario KYC.",
    "chaCompleteKycDescWaPending": "Il tuo KYC è in fase di verifica. Potrai visualizzare il tuo piano una volta verificati i dati dell'azienda.",
    "BLD01643": "Piano WhatsApp",
    "BLD01644": "Aiuto",
    "BLD01645": "Sessioni gratuite",
    "BLD01646": "Le prime 1.000 sessioni di ogni mese di calendario sono gratuite, per consentire all'azienda di creare esperienze gradite ai clienti prima di iniziare a pagare. Queste sessioni possono essere avviate dall'azienda o dall'utente.",
    "BLD01647": "Sessioni avviate dall'azienda o dall'utente al mese",
    "BLD01648": "Le sessioni non vengono addebitate quando gli utenti contattano le aziende tramite pulsanti di invito all'azione (CTA) su annunci che collegano a Whatsapp o CTA su pagine Facebook. La sessione deve essere avviata dall'utente e sarà gratuita solo per la prima volta. Le successive sessioni con l'utente saranno a pagamento.",
    "BLD01649": "Sessioni di referral avviate dall'utente",
    "BLD01650": "Proroga",
    "BLD01651": "Cancellato",
    "BLD01652": "Costi di gestione mensili",
    "BLD01653": "Una volta attivato il piano, la tariffa mensile ricorrente verrà addebitata a partire dal primo giorno del mese successivo.",
    "BLD01653a": "Una volta riattivato il piano, la tariffa mensile ricorrente verrà addebitata a partire dal primo giorno del mese successivo.",
    "BLD01654": "Prossima data di pagamento",
    "BLD01655": "Potrai attivare il piano quando il tuo WABA e almeno un numero di telefono saranno stati approvati.",
    "BLD01656": "Il tuo piano WhatsApp è stato cancellato.",
    "BLD01657": "Costi di gestione mensili non pagati",
    "BLD01658": "Il saldo è insufficiente a pagare i costi di gestione mensili. Ricarica il portafoglio.",
    "BLD01659": "Importo dovuto",
    "BLD01661": "Paga i costi dovuti",
    "BLD01662": "Costo per sessione",
    "BLD01663": "Tutte le conversazioni sono misurate in incrementi di 24 ore, detti \"sessioni\", a partire dalla consegna del primo messaggio da parte dell'azienda. Il primo messaggio può essere inviato spontaneamente (sessione avviata dall'azienda) o in risposta al messaggio di un utente entro 24 ore (sessione avviata dall'utente).",
    "BLD01664": "Il costo verrà addebitato all'inizio di ogni sessione in base al Paese di destinazione",
    "BLD01665": "Paese di destinazione",
    "BLD01666": "Avviata dall'utente",
    "BLD01667": "sessione",
    "BLD01668": "Avviata dall'azienda",
    "BLD01669": "Costo di attivazione una tantum",
    "BLD01670": "Per attivare il piano è richiesto un pagamento una tantum. Una volta attivato il piano, si applicheranno le seguenti tariffe.",
    "BLD01671": "Piano WA attivato correttamente",
    "BLD01672": "Costo di attivazione WA pagato correttamente",
    "BLD01672a": "Piano WA riattivato correttamente",
    "BLD01673": "Ora puoi iniziare a inviare messaggi WhatsApp.",
    "BLD01674": "Ti verrà addebitata una tariffa mensile ricorrente di <b>{{baseCurrencySymbol}}{{package_cost}}<\/b> il <b>{{next_payment_date}}<\/b>",
    "BLD01675": "Approvato",
    "BLD01676": "Limite di utilizzo mensile raggiunto.",
    "BLD01677": "Paga il costo di attivazione e attiva il piano",
    "BLD01678": "Il saldo è insufficiente a pagare il costo di attivazione. Ricarica il portafoglio.",
    "BLD01679": "Le seguenti sessioni sono gratuite ogni mese.",
    "BLD01680": "Paga il costo di attivazione",
    "BLD01680a": "Il pagamento dei costi di gestione mensili del piano WhatsApp non è riuscito. Per pagare l'importo dovuto ",
    "BLD01681": "Attiva il tuo piano WhatsApp",
    "BLD01682": "Paga un costo di attivazione una tantum per attivare il tuo Piano Whatsapp e iniziare a inviare messaggi",
    "BLD01683": "Rinnovo automatico non riuscito. Per pagare i costi di gestione mensili dovuti",
    "BLD01684": "Clicca qui",
    "enableEncryption": "Abilita crittografia",
    "enableCallbackRequiredOptions": "Abilita opzioni di richiamata richiesta",
    "encryptDataAlgorithm": "Crittografa i dati di richiamata con codici e algoritmi specifici. ",
    "selAlgorithm": "Algoritmo",
    "enterKey": "Codice",
    "enterIV": "Vettore di inizializzazione",
    "enterResponseMessage": "Messaggio di risposta",
    "paramsToEncrypt": "Parametri",
    "viewDocumentation": "Vedi la documentazione",
    "ivRequired": "È obbligatorio inserire IV",
    "ivLengthError": "IV deve essere di 16 caratteri",
    "keyLengthError": "La key deve essere di {{length}} caratteri",
    "BLD01685a": "Verrai addebitato sulla base del listino prezzi standard di WhatsApp",
    "KLR00437": "Gruppo di utenti SIP",
    "KLR00438": "Dominio SIP",
    "KLR00439": "ACL SIP",
    "KLR00440": "Domini",
    "KLR00441": "Credenziali",
    "KLR00442": "Aggiungi gruppo di utenti",
    "KLR00443": "Nuovo gruppo di utenti SIP",
    "KLR00444": "Nome utente",
    "KLR00445": "La password deve contenere",
    "KLR00446": "Almeno 12 caratteri",
    "KLR00447": "Conferma password",
    "KLR00448": "Seleziona CLI",
    "KLR00449": "Usa impostazione predefinita",
    "KLR00450": "Elimina gruppo di utenti",
    "KLR00451": 'Confermi di voler eliminare il gruppo di utenti "{{userGroupName}}" ?',
    "KLR00452": "Mapped Domains",
    "KLR00453": "Elimina credenziali",
    "KLR00454": 'Confermi di voler eliminare le credenziali "{{credentialName}}" ?',
    "KLR00455": "Cambia Password",
    "KLR00456": "Aggiungi credenziali",
    "KLR00457": "Nuova password",
    "KLR00458": "Conferma nuova password",
    "KLR00459": "Rename User Group",
    "KLR00460": "Nuovo dominio SIP",
    "KLR00461": "Edit SIP Domain",
    "KLR00462": "Elimina dominio",
    "KLR00463": 'Confermi di voler eliminare "{{domain}}" ?',
    "KLR00464": 'Posizione',
    "KLR00465": 'Gruppi di utenti',
    "KLR00466": "ACL",
    "KLR00467": "Aggiungi dominio",
    "KLR00468": "Posizione dominio",
    "KLR00469": "Seleziona ACL",
    "KLR00470": "Seleziona gruppo di utenti",
    "KLR00471": "Nome del dominio",
    "KLR00472": "Aggiungi nuovo gruppo di utenti",
    "KLR00473": "Domini disponibili",
    "KLR00474": "Domini non disponibili",
    "KLR00475": "There are no user groups to display",
    "KLR00476": "Start adding SIP User Groups",
    "KLR00477": "No credentials added",
    "KLR00478": "There are no credentials to display",
    "KLR00479": "CLI",
    "KLR00480": "Start adding SIP Domain",
    "KLR00481": "There are no domains to display",
    "KLR00482": "Sono consentiti solo lettere, numeri, trattini e underscore",
    "KLR00483": "Il nome utente non può iniziare con un trattino o un trattino basso",
    "KLR00484": "User group created successfully",
    "KLR00485": "User group deleted successfully",
    "KLR00487": "User group updated successfully",
    "KLR00488": "Credential added successfully",
    "KLR00489": "Credential deleted successfully",
    "KLR00490": "Password changed successfully",
    "KLR00491": "Credential updated successfully",
    "KLR00492": "Domain created successfully",
    "KLR00493": "Domain updated successfully",
    "KLR00494": "Domain deleted successfully",
    "KLR00495": "SIP Domains",
    "KLR00496": "Aggiungi un ACL SIP per iniziare",
    "KLR00497": "Non ci sono ACL da mostrare",
    "KLR00498": "Elimina ACL",
    "KLR00499": 'Add IP',
    "KLR00700": 'Aggiungi ACL',
    "KLR00701": "IP Addresses",
    "KLR00702": "Nuovo ACL SIP",
    "KLR00703": "Delete IP Address",
    "KLR00704": "IP Address",
    "KLR00705": "Aggiungi nuovo IP",
    "KLR00706": "Domini SIP associati",
    "KLR00707": "Aggiunto",
    "KLR00708": "ACL deleted successfully",
    "KLR00709": "ACL created successfully",
    "KLR00710": "Rinomina ACL",
    "KLR00711": "ACL updated successfully",
    "KLR00712": "Seleziona ACL",
    "A maximum of 10 IPs can be added per ACL": "È possibile aggiungere fino a 10 IP per ACL",
    "A maximum of 10 ACLs can be added per account": "È possibile aggiungere fino a 10 ACL per account",
    "Invalid Caller ID. Please choose a Voice (SIP enabled) Caller ID to dial to a SIP endpoint": "ID chiamante non valido. Seleziona un ID chiamante (abilitato SIP) per chiamare un endpoint SIP",
    "Invalid SIP endpoint": "IEndpoint SIP non valido",
    "KLR00713": "IEndpoint SIP non valido",
    "Please provide a valid number with country code.": "Inserisci un numero valido incluso il prefisso internazionale.",
    "KLR00714": "Inserisci un numero valido incluso il prefisso internazionale.",
    "KLR00715":"10DLC",
    "KLR02538" : "Play Audio",
    "KLR02879": "Temporanea non disponibilità del Servizio Conversations",
    "KLR02880": "Ci scusiamo per il disagio. il servizio sarà disponibile a breve.",
    "KLR02881": "Grazie per la vostra comprensione",
    "KLR04050" : "data di abbonamento",
    "KLR04000": "Shared Mobile",
    "KLR04001": "Mobile",
    "KLR08000": "Richiedi l'accesso per l'account e-mail",
    "KLR02887": "Il Modulo di Conversations è temporaneamente non disponibile.",

    callbackAutomatedReport: 'Callback Report',
	callbackAutomatedReportDesc:
		'Una mail verrà inviata con il conteggio di tutti i callback falliti e non. Può essere programmata quotidianamente/settimanalmente/mensilmente.',
    dailyCallbackReportDesc: "Ricevi un report giornaliero alle 17:00",
    weeklyCallbackReportDesc: "Ricevi un report ogni mercoledì",
    monthlyCallbackReportDesc: "Ricevi un report ogni 25 del mese",
	selChannelApi: "Seleziona l'API del canale",
	selEvent: "Seleziona l'evento",
	dynamicVariablesHeader: 'Variabili dinamiche',
  retriesHeader: "Riprovare",
  "nRetriesDescription": "Numero di tentativi",
  "retriesWarning":"Per più di 2 tentativi, contattare il team di supporto",
  "timeoutInMilliSeconds": "Timeout in millisecondi",
  "timeIntervalInSeconds": "Time Interval in secondi",
  "firstRetryLabelSection": "Primo tentativo",
  "secondRetryLabelSection": "Secondo tentativo",
  enableFormData: "Abilita headers di form data o urlencoded",
  selectFormDataOrUrlEncoded: "Seleziona header form data or urlencoded",
	dynamicVariablesDescription:
		"Le variabili dinamiche sono usate dall'API per ricevere dati addizionali",
    dynamicVarEvents: "Eventi per il canale selezionato",
    "verifyRetriggerCallbacks": "Sei sicuro di rilanciare le ultime richieste fallite durante gli ultimi 30 giorni?",
    "verifyRetriggerConfirmation": "Conferma",
    "unsupportedTLSVersionMessage": "L'URL di questo profilo utilizza una versione TLS non supportata (<1.2), si consiglia di aggiornare la versione TLS per evitare problemi di sicurezza.",
    "callbacksLogsDate": "Data",
    "callbacksLogsProfileID": "Profilo Callback",
    "callbacksLogsMessageID": "Message ID",
    "callbacksLogsURLHit": "URL raggiunto",
    "callbacksLogsResponseCode": "Codice di risposta",
}
